export default {
  "date": {
    "order": [
      "year",
      "month",
      "day"
    ],
    "month": "মাস ",
    "day": "দিন ",
    "year": "বছর ",
    "january": "জানুয়ারী ",
    "february": "ফেব্রুয়ারি ",
    "march": "মার্চ",
    "april": "এপ্রিল",
    "may": "মে",
    "june": "জুন",
    "july": "জুলাই",
    "august": "আগস্ট",
    "september": "সেপ্টেম্বর",
    "october": "অক্টোবর",
    "november": "নভেম্বর",
    "december": "ডিসেম্বর"
  },
  "user": {
    "send_appointment_confirmation_message": "আপনার অ্যাপয়েন্টমেন্ট {{name}} এর জন্য সুনিশ্চিত করা হয়েছে।",
    "landline_appointment_reminder_message": "হ্যালো, {{full_name}}। {{name}} তে আপনার অ্যাপয়েন্টমেন্টের জন্য আমরা আপনাকে মনে করিয়ে দিচ্ছি। আপনার অ্যাপয়েন্টমেন্ট {{date}} তারিখে {{time}} টায় {{address}} এ হবে।",
    "send_at_home_visit_confirmation_message": "আপনার অ্যাপয়েন্টমেন্ট {{date}} তারিখে {{time}} টার পরে সুনিশ্চিত করা হয়েছে।",
    "send_mail_order_confirmation_message": "আপনার মেল অর্ডার সুনিশ্চিত করা হয়েছে",
    "send_waitlist_message": "আপনি {{name}} এর জন্য অপেক্ষা তালিকাভুক্ত হয়েছেন। আমরা অ্যাপয়েন্টমেন্টের সময় নিশ্চিত না হওয়া পর্যন্ত অনুগ্রহপূর্বক উপস্থিত হবেন না।",
    "verify_contact": {
      "phone": "অনুগ্রহপূর্বক {{confirmation_link}} এ ক্লিক করে আপনার ফোন নম্বর নিশ্চিত করুন",
      "email": "{{confirmation_link}}"
    },
    "duplicate_user_continue_registering": "এখানে অ্যাপয়েন্টমেন্টের জন্য নিবন্ধন করুন: {{url}}",
    "on_demand_confirmation_message": "আপনার নাম {{name}} সফলভাবে নিবন্ধিত হয়েছে।",
    "appointment_reminder": "{{start_time}} টায় আপনার অ্যাপয়েন্টমেন্টের আগে, অনুগ্রহপূর্বক যে কোন বিষয় সম্পন্ন করতে এবং আপনার নিবন্ধন নিশ্চিতকরণ দেখতে লিঙ্কে ক্লিক করুন। অনুগ্রহপূর্বক আপনার অ্যাপয়েন্টমেন্টের ১৫ মিনিটের পূর্বে উপস্থিত হবেন না।",
    "appointment_reminder_base": "{{text}} এখানে ক্লিক করুন: {{link}}",
    "test_result_notifier": {
      "text_message": "{{first_name_with_last_initial}}-এর রোগীর পোর্টাল আপডেট করা হয়েছে। {{url}}-এ যান এবং কোড ব্যবহার করুন: {{access_code}}",
      "email_subject": "আপনার রোগীর পোর্টালে নতুন আপডেট",
      "email_intro": "হ্যালো {{first_name_with_last_initial}}",
      "email_p1": "একটি নতুন বার্তা বা রোগীর আপডেট আপনার জন্য উপলব্ধ।",
      "email_p2": "নীচের বোতামে ক্লিক করুন বা আপনার রোগীর পোর্টাল দেখতে এবং কোড ব্যবহার করতে লিঙ্কটি ব্যবহার করুন",
      "email_p3": "রোগীর পোর্টাল এখানে দেখুন:'",
      "email_button": "পোর্টাল দেখুন"
    },
    "landline_appointment_reminder_message_without_time": "হ্যালো, {{full_name}}। আমরা আপনাকে মনে করিয়ে দিচ্ছি যে {{name}} তে আপনার একটি অ্যাপয়েন্টমেন্ট আছে। {{date}} তারিখে {{address}} ঠিকানায় আপনার অ্যাপয়েন্টমেন্ট আছে।",
    "appointment_reminder_on_demand": "{{date}} তারিখে আপনার অ্যাপয়েন্টমেন্টের আগে, অনুগ্রহপূর্বক যে কোন অসম্পূর্ণ বিষয় সম্পন্ন করতে এবং আপনার নিবন্ধন নিশ্চিতকরণ দেখতে লিঙ্কে ক্লিক করুন।",
    "new_test_result_notifier": {
      "email_intro": "আপনার রোগীর পোর্টাল আপডেট করা হয়েছে।",
      "email_text_1": "কোনো নতুন রোগীর রেকর্ড বা ল্যাব রিপোর্ট দেখতে নিচে আপনার মেডিকেল হিস্ট্রি পোর্টালে যান।",
      "email_button": "চিকিৎসার ইতিহাস",
      "email_text_2": "আপনি এই ইউআরএল টি আপনার ব্রাউজারে কপি করতে পারেন:"
    },
    "mailers": {
      "email_contact_us": "কোনো প্রশ্ন আছে? আমাদের সাথে যোগাযোগ করুন"
    }
  },
  "errors": {
    "generic": {
      "message": "কোন একটি ভুল হয়েছে। আবার চেষ্টা করুন"
    },
    "messages": {
      "blank": "ফাঁকা রাখা যাবে না"
    },
    "incorrect_credentials": "আপনার দেওয়া তথ্য সঠিক নয়। আরেকবার চেষ্টা করুন।",
    "error_activating_test_kit": "টেস্ট কিট অ্যাক্টিভেট করায় সমস্যা দেখা দিয়েছে।"
  },
  "type": "টাইপ করুন ",
  "payment": {
    "continue_label": "পেমেন্ট প্রদান করতে সামনে অগ্রসর হউন ",
    "policy_text": "আপনি যদি আপনার অ্যাপয়েন্টমেন্ট বাতিল করেন বা না এসে থাকেন, তাহলে আমরা আপনার অ্যাপয়েন্টমেন্টের তারিখের ৭ দিন পরে আপনার পেমেন্টের ৮০% ফেরত দেব। আপনি সম্পূর্ণ [পরিষেবার শর্তাবলী] দেখতে পারেন এখানে ({{link}})",
    "card_number": " কার্ড নম্বর ",
    "expiry_date": "মেয়াদ শেষ হওয়ার তারিখ",
    "pay_button": "পেমেন্ট প্রদান করুন ",
    "no_credit_card": "আমি সাইটে পরিশোধ করব",
    "cash_payment_helper": "অনুগ্রহপূর্বক আপনার অ্যাপয়েন্টমেন্টে **{{payment}} ** আনতে ভুলবেন না",
    "invoice": "চালান",
    "pay_by_card": "কার্ডের মাধ্যমে পেমেন্ট করুন ",
    "cost": "খরচ ",
    "total": "সর্বমোট ",
    "pay_cash_at_appointment": "আমি আমার {{appointment}} অ্যাপয়েন্টমেন্টের সময় নগদ অর্থ প্রদান করব",
    "view_invoice": "চালান দেখুন/প্রিন্ট করুন ",
    "refund_policy": "আপনি যদি আপনার অ্যাপয়েন্টমেন্ট বাতিল করেন, আমরা আপনার অ্যাপয়েন্টমেন্টের তারিখের 7 দিন পরে আপনার পেমেন্টের {{amount}} ফেরত দেব। আপনি সম্পূর্ণ [সেবার দল]({{link}}) দেখতে পারেন",
    "refund_window_passed": "অ্যাপয়েন্টমেন্টের সময় অতিবাহিত হওয়ার কারণে আপনার অ্যাপয়েন্টমেন্ট ফেরত পাওয়ার যোগ্য নয়। যেকোন রেজোলিউশনের জন্য অনুগ্রহ করে সরাসরি সাইট কোঅর্ডিনেটরদের সাথে যোগাযোগ করুন।",
    "amount_paid": "পরিশোধের পরিমাণ",
    "balance": "অবশিষ্ট"
  },
  "consent_waiver": {
    "upload_waiver_or_sign": "সম্মতিপত্র আপলোড করুন অথবা নীচের স্বাক্ষর বাক্সে স্বাক্ষর করুন",
    "stop": "নিবন্ধন সম্পন্ন করতে সম্মতি প্রয়োজন",
    "parent_or_guardian_required_html": "আপনার রেজিস্ট্রেশন চূড়ান্ত করার জন্য, আপনার পিতামাতা, অভিভাবক বা অনুমোদিত সিদ্ধান্ত গ্রহণকারীকে অবশ্যই নীচের ফর্মটিতে সম্মতি প্রদান করতে হবে এবং তাদের নাম স্বাক্ষর করতে হবে। আপনি <b>নিজে থেকে এই পরিষেবাতে সম্মতি দিতে পারবেন না </b>।",
    "send_parent_or_guardian": "আপনি আপনার পিতামাতা বা অভিভাবককে এই লিঙ্কটি পাঠাতে পারেন অথবা এই পৃষ্ঠায় নীচে তাদের স্বাক্ষর নিতে পারেন।",
    "consent_guardian_name_signature": "ভালো নাম",
    "consent_for_minor": "অপ্রাপ্তবয়স্কের পক্ষে সম্মতিপত্রে স্বাক্ষর করুন",
    "guardian_signature": "পিতামাতা, অভিভাবক বা অনুমোদিত চিকিৎসা সিদ্ধান্ত গ্রহণকারীর স্বাক্ষর",
    "after_you_schedule": "{{age}} বছরের কম বয়সী অংশগ্রহণকারীদের অবশ্যই তাদের পক্ষে একজন অভিভাবক বা অভিভাবক দ্বারা স্বাক্ষরিত সম্মতিপত্র থাকতে হবে। আপনার অভিভাবকের কাছে পাঠানোর জন্য অথবা আপনার অপ্রাপ্তবয়স্ক ব্যক্তির জন্য স্বাক্ষর করতে অনুগ্রহপূর্বক নিবন্ধন শেষ পর্যন্ত চালিয়ে যান।",
    "consent_guardian_last_name_signature": "পারিবারিক নাম",
    "consent_first_and_last_name": "ভালো নাম ও পারিবারিক নাম",
    "phone_number": "অভিভাবকের ফোন নম্বর",
    "email": "অভিভাবক ইমেইল",
    "consent_registrar_with_guardian_name_signature": "অভিভাবকের নামের প্রথম অংশ",
    "consent_registrar_with_guardian_last_name_signature": "অভিভাবকের নামের শেষের অংশ",
    "consent_registrar_first_name_signature": "রেজিস্ট্রারের নামের প্রথম অংশ",
    "consent_registrar_last_name_signature": "রেজিস্ট্রারের নামের শেষের অংশ",
    "consent_on_behalf": "আমি {{first_name}} {{last_name}} এর পক্ষে সাক্ষর করছি।",
    "consent_on_behalf_registrar": "আমি {{first_name}} {{last_name}} তাদের পক্ষে স্বাক্ষর করার জন্য মৌখিকভাবে অনুমোদিত হয়েছি।",
    "consent_on_behalf_registrar_with_guardian": "আমি {{first_name}} {{last_name}} তাদের অভিভাবক দ্বারা স্বাক্ষর করার জন্য মৌখিকভাবে অনুমোদিত হয়েছি।",
    "registrar_phone": "নিবন্ধকের ফোন নম্বর",
    "registrar_email": "নিবন্ধকের ই মেল",
    "consented_by_parent_guardian": "পিতা বা মাতা / অভিভাবক",
    "consented_by_decision_maker": "অনুমোদিত চিকিৎসা-বিষয়ক সিদ্ধান্ত গ্রহণকারী",
    "consented_by_guardian_verbal": "অভিভাবকের সহিত নিবন্ধক (মৌখিক সম্মতি নেওয়া হয়েছে)",
    "consented_by_registrar": "নিবন্ধক (মৌখিক সম্মতি নেওয়া হয়েছে)",
    "full_name": "পুরো নাম",
    "print": "প্রিন্ট"
  },
  "registration": {
    "contact_information": "নাম ও ঠিকানা",
    "contact_information_additional": "অ্যাপয়েন্টমেন্ট জন্য যোগাযোগ ও ফলাফলের জন্য পিতামাতা বা অভিভাবকের যোগাযোগের তথ্য",
    "personal_information": "জনসংখ্যার তথ্য",
    "address_placeholder": "অনুগ্রহপূর্বক আপনার বাসার ঠিকানা প্রদান করুন ",
    "first_name_label": "ভালো নাম",
    "last_name_label": "পারিবারিক নাম",
    "errors": {
      "state": "অবশ্যই ২ অক্ষরের বৈধ স্টেট কোড প্রদান করুন ",
      "phone_number_invalid": "ফোন নম্বর সঠিক নয় ",
      "required": "এই তথ্য অবশ্যই প্রদান করতে হবে ",
      "email_domain": "আপনার এন্ট্রি বৈধ নয়; দয়া করে দুবার যাচাই করুন। নিবন্ধন স্পন্সর সংস্থা দ্বারা নির্বাচিত অংশগ্রহণকারীদের মধ্যে সীমাবদ্ধ। আপনার কাজ বা কমিউনিটি ইমেল ব্যবহার করে দেখুন। যদি আপনি মনে করেন যে আপনি যোগ্য এবং এখানে কোন সমস্যা আছে, তাহলে অনুগ্রহপূর্বক সাপোর্ট সেন্টারের সাথে যোগাযোগ করুন।",
      "age_requirement": "জন্ম তারিখ বয়সের শর্ত পূরণ করে না",
      "signature_required": "স্বাক্ষর অবশ্যই প্রদান করতে হবে ",
      "regex_invalid": "এই মানটি অবৈধ বলে মনে হচ্ছে।",
      "date_invalid": "এই তারিখটি বিদ্যমান নেই",
      "invalid_entry": "অনুগ্রহপূর্বক নিবন্ধন চালিয়ে যাবেন না। পর্দায় প্রদর্শনকৃত নির্দেশাবলী অনুসরণ করুন অথবা আপনার যোগাযোগের স্থানে পৌঁছান।",
      "city": "অবশ্যই বৈধ শহরের নাম প্রদান করতে হবে",
      "survey_unanswered": "অনুগ্রহপূর্বক পরীক্ষা করুন যে *  দিয়ে চিহ্নিত সকল অবশ্যই পূরণীয় প্রশ্নের উত্তর দেওয়া হয়েছে।",
      "postal_code": "অবশ্যই ৫ সংখ্যার বৈধ পোস্টাল কোড প্রদান করুন ",
      "field_required": "{{field}} এ তথ্য দেয়া আবশ্যিক",
      "option_required": "আপনাকে অবশ্যই একটি বিকল্প নির্বাচন করতে হবে",
      "year_length_invalid": "আপনার জন্মদিন চার সংখ্যার সাল সহ লিখুন ",
      "invalid_day": "দিন ১থেকে ৩১ এর মধ্যে হতে হবে",
      "reached_max_chars": "আপনি অক্ষরের সর্বোচ্চ মাত্রায় পৌছেছেন।",
      "chars_max": " সর্বোচ্চ অক্ষর",
      "minimum_length": "আপনার ইনপুটে অন্তত {{length}} টি অক্ষর থাকতে হবে।"
    },
    "insurance_status": {
      "question": "আপনার কি স্বাস্থ্য বীমা আছে? ",
      "have_health_insurance": "হ্যাঁ, আমার স্বাস্থ্য বীমা আছে",
      "do_not_have_health_insurance": "না, আমার স্বাস্থ্য বীমা নেই"
    },
    "insurance_policy_holder": {
      "question": "পলিসি হোল্ডার কে?",
      "i_am": "আমি ",
      "my_spouse": "আমার স্বামী/স্ত্রী বা পার্টনার ",
      "my_parents": "আমার পিতামাতা ",
      "someone_else": "অন্য কেউ ",
      "policy_first_name": "পলিসি হোল্ডারের নামের প্রথম অংশ ",
      "policy_last_name": "পলিসি হোল্ডারের নামের শেষ অংশ ",
      "policy_dob": "পলিসি হোল্ডারের জন্ম তারিখ ",
      "name": "পলিসি ধারকের নাম"
    },
    "insurance_information": {
      "title": "বীমা সম্পর্কিত তথ্য ",
      "company_name": "বীমা কোম্পানির নাম",
      "id_number": "সদস্য পরিচয় নম্বর",
      "group_number": "সদস্য গ্রুপ নম্বর ",
      "secondary_insurance_label": "আমার সেকেন্ডারি ইন্স্যুরেন্স আছে",
      "take_photo": "আপনার ইনসিওরেন্স কার্ডের একটি ছবি তুলুন। ছবি দিলে আপনার কিছু তথ্য নিজে থেকেই পূর্ণ হয়ে যাবে।",
      "front_of_card": "কার্ডের সামনের পিঠ",
      "card_information": "ইনসিওরেন্স কার্ডের তথ্য",
      "back_of_card": "কার্ডের পিছনের পিঠ"
    },
    "employment_information": {
      "label": "কর্মসংস্থান",
      "address_1": "কোম্পানির ঠিকানা",
      "address_2": "যেমন: স্যুইট 200",
      "phone_number": "কোম্পানির ফোন নম্বর",
      "company": "কোম্পানির নাম",
      "postal_code": "নিয়োগকর্তার পোস্টাল কোড",
      "employed": "নিয়োগপ্রাপ্ত ব্যক্তি ",
      "sole_prorietor": "একক স্বত্বাধিকারী",
      "not_employed": "বেকার",
      "reporting_supervisor": "রিপোর্টিং সুপারভাইজার",
      "reporting_department": "রিপোর্ট বিভাগ",
      "supervisor_name": "সুপারভাইজারের  নাম",
      "supervisor_email": "সুপারভাইজারের ইমেল"
    },
    "location_availability": "বর্তমানে এই এলাকায় বসবাসকারী সম্প্রদায়ের সদস্যদের জন্য পরীক্ষার জন্য অগ্রাধিকার দেওয়া হয়েছে",
    "custom_survey": "প্রশ্নপত্র",
    "confirmation": "পুনঃমূল্যায়ন",
    "waitlisted": "অপেক্ষমান তালিকা",
    "schedule_your_appointment": "নির্ধারিত অ্যাপয়েন্টমেন্ট",
    "information": "তথ্য ",
    "consent": "সম্মতিপত্র ",
    "location": "স্থান ",
    "symptoms": "উপসর্গ বা লক্ষণ ",
    "address_required": "অনুগ্রহপূর্বক আপনার ঠিকানা প্রদান করুন ",
    "consent_required": "নিবন্ধন সম্পন্ন করতে সম্মতি প্রদান করুন ",
    "required_field": "অবশ্যই পূরণীয় ক্ষেত্র নির্দেশ করে",
    "phone_number": "মোবাইল ফোন নম্বর ",
    "email": "ইমেইল ",
    "date_of_birth": "জন্ম তারিখ ",
    "minimum_age": "অংশগ্রহণের সর্বনিম্ন বয়স {{year}} বছর।",
    "no_minimum_age": "পরীক্ষার জন্য কোন ন্যূনতম বয়স নেই",
    "continue_button": "চলমান ",
    "email_required": "এই মানটি একটি বৈধ ইমেল হওয়া উচিত।",
    "done": "সম্পন্ন ",
    "signature": "স্বাক্ষর ",
    "clear_button": "পরিস্কার ",
    "back_button": "পিছনে ",
    "choose_location": "স্থান নির্বাচন করুন ",
    "no_slots": "{{location}} এ আর কোন স্লট অবশিষ্ট নেই ",
    "choose_appointment": "{{location}} এ অ্যাপয়েন্টমেন্টের সময় বেছে নিন",
    "appointment_required": "অনুগ্রহপূর্বক অ্যাপয়েন্টমেন্ট সময় নির্বাচন করুন",
    "phone_number_required": "ফোন নম্বর বৈধ নয় ",
    "phone_number_label": "দ্রুত পরীক্ষার ফলাফলের জন্য টেক্সট মেসেজ পেতে পারে একটি নম্বর প্রদান করুন ",
    "symptoms_experiencing": "আপনি বর্তমানে যে উপসর্গগুলো অনুভব করছেন সেগুলোতে ক্লিক করুন। যদি আপনার কোন উপসর্গ না থাকে, অনুগ্রহপূর্বক সামনে যান।",
    "household": "পরিবারের সদস্যগন",
    "household_p1": "ঐচ্ছিকভাবে, পরিবারের সদস্যদের জন্য একটি অ্যাপয়েন্টমেন্ট তৈরি করুন যাদের পরীক্ষা করা দরকার।",
    "add_dependent": "পরিবারের সদস্য যোগ করুন",
    "remove_dependent": "নির্ভরশীল ব্যক্তিকে সরান",
    "dependent_consents": "সম্মতি",
    "submit": "সম্পূর্ণ",
    "add_waitlist": "অপেক্ষমান তালিকায় যোগ করুন",
    "address": "বাসার ঠিকানা",
    "address_1": "ঠিকানা লাইন ১",
    "address_2": "এপাঃ/ স্যুইট# ",
    "address_city": "শহর",
    "address_state": "রাষ্ট্র",
    "postal_code": "পোস্টাল কোড ",
    "race_ethnicity": "বর্ণ ",
    "gender": "লিঙ্গ পরিচয়",
    "self_described_gender": "স্ব -বর্ণিত লিঙ্গ",
    "interpreter": "দোভাষীর প্রয়োজন? যদি হ্যাঁ হয়, তাহলে কোন ভাষা?",
    "consent_to_terms": "আমি এই শর্তাবলীতে সম্মতি জানাচ্ছি।",
    "reg_not_open": "নিবন্ধন খোলা হয়নি",
    "no_more_avail_spots": "আপনার নির্বাচিত টাইম স্লট আর অবশিষ্ট নেই। অনুগ্রহপূর্বক আবার চেষ্টা করুন.",
    "consent_helper": "সাইন করার জন্য নিচের বাক্সে আপনার মাউস বা আঙুলটি ক্লিক করুন এবং টেনে আনুন",
    "phone_number_unreachable_label": "ল্যান্ডলাইন ",
    "select": "নির্বাচন ",
    "test_surveys": "অ্যাপোয়েনমেন্টের প্রশ্ন",
    "edit": "সম্পাদনা/ সংশোধন ",
    "continue_to_registration": "নিবন্ধন চালিয়ে যান",
    "accounts": {
      "already_have_an_account": "ইতিমধ্যে একটি একাউন্ট আছে?",
      "log_in": "লগ ইন",
      "sign_up": "সাইন আপ / নিবন্ধন করুন ",
      "sign_up_description": "আপনার একাউন্ট তৈরি করতে এবং ভবিষ্যতে নিবন্ধনের সময় বাঁচাতে অনুগ্রহপূর্বক আপনার তথ্য লিখুন।",
      "log_in_description": "অনুগ্রহ করে আপনার ই-মেইল এবং পাসওয়ার্ড প্রদান করুন, অথবা নীচে গুগল বা আউটলুকের মাধ্যমে সাইন ইন করুন",
      "sign_in_with_label": "{{provider}} দিয়ে প্রবেশ করুন",
      "password_must_match": "পাসওয়ার্ড অবশ্যই মিলতে হবে",
      "password_uppercase": "আপনার পাসওয়ার্ডে কমপক্ষে (%s) বড় হাতের অক্ষর থাকতে হবে।",
      "password_lowercase": "আপনার পাসওয়ার্ডে কমপক্ষে (%s) ছোট হাতের অক্ষর থাকতে হবে।",
      "password_number": "আপনার পাসওয়ার্ডে কমপক্ষে (%s) সংখ্যা থাকতে হবে।",
      "password_special": "আপনার পাসওয়ার্ডে কমপক্ষে (%s) বিশেষ অক্ষর থাকতে হবে।"
    },
    "password": "পাসওয়ার্ড",
    "password_confirmation": "পাসওয়ার্ড নিশ্চিতকরণ",
    "consent_for": "{{name}} এর জন্য সম্মতি",
    "book_one_time_appointment": "ওয়ান-টাইম অ্যাপয়েন্টমেন্ট বুক করুন",
    "duplicate_users": {
      "exists": "আপনি ইতোমধ্যে নিবন্ধিত",
      "overlapping_email_and_phone_p1": "আমরা আপনার ফোন নম্বরে এবং ইমেইলে একটি বার্তা পাঠিয়েছি।",
      "p2": "আপনার বার্তা ব্যবহার করে, আপনি আপনার অ্যাপয়েন্টমেন্ট পরিবর্তন করতে পারেন অথবা পরীক্ষার ফলাফল লিখতে পারেন।",
      "overlapping_phone_and_email_p3": "বিস্তারিত জানতে আপনার ইমেইল বা ফোন চেক করুন।",
      "overlapping_email_p3": "বিস্তারিত জানতে আপনার ইমেইল দেখুন।",
      "overlapping_phone_p3": "বিস্তারিত জানতে আপনার ফোন চেক করুন।",
      "overlapping_phone_p1": "আমরা আপনার ফোন নম্বরে একটি বার্তা পাঠিয়েছি।",
      "overlapping_email_p1": "আমরা আপনার ইমেইলে একটি বার্তা পাঠিয়েছি।",
      "p4": "যদি আপনি মনে করেন এখানে কোন সমস্যা হয়েছে, তাহলে অনুগ্রহপূর্বক  support@primary.health এ আমাদের সাথে যোগাযোগ করুন",
      "overlapping_email_and_phone_p3": "বিস্তারিত জানতে আপনার ইমেইল বা ফোন চেক করুন।"
    },
    "duplicate_waitlist": {
      "exists": "আপনি ইতিমধ্যে অপেক্ষামান তালিকায় আছেন",
      "overlapping_email_and_phone_p1": "আমরা আপনার ফোন নম্বরে এবং ইমেইলে আরেকটি নিশ্চিতকরণ বার্তা পাঠিয়েছি",
      "p2": "আপনার নিশ্চিতকরণ বার্তা ব্যবহার করে, আপনি অতিরিক্ত তথ্য প্রদান করতে পারেন অথবা অপেক্ষমান তালিকা থেকে নিজেকে সরিয়ে নিতে পারেন।",
      "overlapping_phone_and_email_p3": "বিস্তারিত জানতে আপনার ইমেইল বা ফোন চেক করুন",
      "overlapping_email_p3": "বিস্তারিত জানতে আপনার ইমেইল দেখুন",
      "overlapping_phone_p3": "বিস্তারিত জানতে আপনার ফোন চেক করুন",
      "overlapping_email_p1": "আমরা আপনার ইমেইলে আরেকটি নিশ্চিতকরণ বার্তা পাঠিয়েছি।"
    },
    "insist_guardian_consent": "আমি ... এর পক্ষে সম্মতি প্রদান করছি",
    "confirmation_section": {
      "title": "পর্যালোচনা করুন এবং নিশ্চিত করুন",
      "p1": "নিবন্ধন সম্পন্ন করার আগে আপনার তথ্য পর্যালোচনা করুন।",
      "edit_information": "ফিরে যান এবং সম্পাদনা/সংশোধন করুন"
    },
    "iemodal": {
      "title": "অসমর্থিত ব্রাউজার",
      "body": "বর্তমানে এই ব্রাউজারে নিবন্ধন সম্ভব"
    },
    "show_other_locations": "অন্যান্য লোকেশন দেখাতে ক্লিক করুন",
    "non_us_address": "এটি একটি আন্তর্জাতিক ঠিকানা",
    "test_group_user_survey": "অংশগ্রহণকারী স্ক্রিনিং",
    "self_consent": "আমি নিজের জন্য সম্মতি জানাচ্ছি",
    "address_country": "দেশ",
    "appointment": "অ্যাপয়েন্টমেন্ট",
    "employee_id": "কর্মচারী আইডি ",
    "appointment_time": "অ্যাপয়েন্টমেন্টের সময়",
    "appointment_location": "স্থান",
    "phone_or_email": "ফোন নম্বর অথবা ইমেইল",
    "no_self_consent": "আমি নিজের জন্য সম্মতি অস্বীকার করি",
    "no_insist_guardian_consent": "আমি {{full_name}} এর হয়ে সম্মতি প্রত্যাখ্যান করছি",
    "minimum_age_with_months": "অংশগ্রহণের ন্যূনতম বয়স {{year}} বছর {{month}} মাস।",
    "additional_consents_helpertext": "অতিরিক্ত সম্মতি পরে অনুরোধ করা হতে পারে",
    "assistive_technology": "সহায়ক প্রযুক্তি",
    "covid_vaccine_y_n": "আপনি কি এই বুকিং দিয়ে কোভিড-১৯ টিকা দিতে চান?",
    "received_covid_vaccine_y_n": "আপনি কি আগে কোভিড-১৯ টিকা পেয়েছেন?",
    "covid_vaccinations": "কোভিড-১৯ টিকা",
    "select_vaccine_dose": "আপনি যে টিকা ডোজ পেতে চান অনুগ্রহ করে নির্বাচন করুন",
    "demographic_info": "জনসংখ্যার তথ্য",
    "additional_info": "অতিরিক্ত তথ্য",
    "self_described_race": "স্ব-বর্ণিত জাতি পরিচয়",
    "verify_contact_information": "প্রতিপাদন",
    "verify_contact": {
      "we_sent_you_a_code": "অনুগ্রহ করে আমরা {{contact}} এ যে কোডটি পাঠিয়েছি তা লিখুন",
      "confirmation_code": "নিশ্চিতকরণ কোড",
      "code_resent": {
        "email": "আপনার ইমেইলে আরেকটি কোড পাঠানো হয়েছে",
        "phone_number": "আপনার ফোনে আরেকটি কোড পাঠানো হয়েছে"
      },
      "did_not_receive_code": "নিশ্চিতকরণ কোড পাননি?",
      "verify_by": {
        "email": "পরিবর্তে ইমেল দ্বারা যাচাই করুন",
        "phone_number": "পরিবর্তে ফোন নম্বর দ্বারা যাচাই করুন"
      }
    },
    "preferred_method_of_communication": {
      "question": "আপনার পছন্দের যোগাযোগ মাধ্যমন",
      "helper_text": "আমরা আপনার সাথে যোগাযোগ করে অ্যাপয়েন্টমেন্ট সংক্রান্ত আপডেট জানিয়ে দেব",
      "phone_number": "ফোন নম্বর (এস এম এস এবং ডেটা চার্জ প্রযোজ্য)",
      "landline": "আমরা এই মুহূর্তে ল্যান্ডলাইন নম্বর গ্ৰহণ করছিনা। জরুরি যোগাযোগের জন্য ই মেল আই ডি প্রদান করুন।",
      "verification_method": "আপনি কোন মাধ্যমে অথেন্টিকেশন কোড পেতে চান?",
      "verification_helper_text": "লগ ইন করার আগে আপনার কাছে একটি কোড যাবে আপনার পরিচয় সুনিশ্চিত করার জন্য।"
    },
    "skip_for_now": "আপাতত এড়িয়ে যান",
    "default_information": {
      "title": "ঠিক আছে, আমরা এই ঠিকানাটি ব্যাবহার করবো",
      "title_v2": "ঠিক আছে, আমরা এই যোগাযোগের তথ্য ব্যবহার করব"
    },
    "middle_name_label": "মাঝের নাম",
    "confirm_appointment": "অ্যাপয়েন্টমেন্ট সুনিশ্চিত করূন",
    "dob": "জন্মতারিখ",
    "different_appointment": "আলাদা অ্যাপয়েন্টমেন্ট",
    "select_appointment_time": "অ্যাপয়েন্টমেন্টের সময় সুনিশ্চিত করুন",
    "decline_address": "আমি ঠিকানা দিতে অনিচ্ছুক। প্রোগ্রামের ঠিকানা ব্যবহার করুন।",
    "patient_information": "রোগীর বিবরণ",
    "scan_license": "ড্রাইভিং লাইসেন্স স্ক্যান করুন",
    "how_to_contact": "আমরা আপনার সাথে কিভাবে যোগাযোগ করতে পারি?",
    "decline_email_or_phone": "আমি ই মেল বা ফোন নম্বর দিতে অনিচ্ছুক। আমি প্রোগ্রামের অ্যাডমিনিস্ট্রেটর কে আমার ফলাফল গ্ৰহণ করার জন্য অনুমোদন দিচ্ছি।",
    "medical_screening": "চিকিৎসামূলক পরিক্ষা",
    "show_service_at_this_location": "এই এলাকায় পরিষেবা দেখান",
    "verbal_consent_provided": "আমেরিকান্স উইথ ডিসেবিলিটিস আইন অনুযায়ী অংশগ্রহণকারী বা তার আইন অনুমোদিত সিদ্ধান্ত গ্ৰহণকারী মৌখিক সম্মতি দিয়েছেন। অংশগ্রহণকারী বা তার আইন অনুমোদিত সিদ্ধান্ত গ্ৰহণকারীর কাছ থেকে 24 ঘন্টার মধ্যে লিখিত সম্মতি নেওয়া হবে।",
    "unexpired_written_consent_present": "টেস্টিং সাইটে মেয়াদোত্তীর্ণ লিখিত সম্মতি পত্র আছে।",
    "select_to_proceed": "এগোনোর জন্য উপরোক্ত একটি বিকল্প নির্বাচন করুন।",
    "guardians_information": "অভিভাবকের বিবরণ",
    "registrars_information": "নিবন্ধকের বিবরণ",
    "optional": "ঐচ্ছিক",
    "vfc_eligibility": "ভ্যাকসিন ফর চিলড্রেন (ভি এফ্ সি) এর জন্য যোগ্যতা",
    "vfc_eligibility_subtext": "আপনার সন্তান সি ডি সি এর ভ্যাকসিন ফর চিলড্রেন (ভি এফ্ সি) প্রোগ্রামের আওতায় থাকা স্বাস্থ্যসেবা প্রদানকারীর অফিস, ওষুধের দোকান, ও ক্লিনিক থেকে বিনামূল্যে ভ্যাকসিন পেতে পারে। ",
    "consent_for_services": "সেবার জন্য সম্মতি",
    "view_all_items_for_consent": "সম্মতির সব জিনিস দেখান"
  },
  "gender_key": {
    "male": "পুরুষ",
    "female": "নারী ",
    "cisgender": "সিসজেন্ডার",
    "non_binary": "জেন্ডারকিউর বা নন-বাইনারি",
    "other": "অন্যান্য",
    "prefer_to_self_describe": "ইন্ডেন্টিটি তালিকাভুক্ত নয়",
    "prefer_not_to_disclose": "উত্তর প্রদান করতে অনিচ্ছুক",
    "transgender_male": "ট্রান্স মেল/ ট্রান্সম্যান",
    "transgender_female": "ট্রান্স ফিমেল/ ট্রান্সওম্যান",
    "unknown": "অজানা",
    "non_binary_only": "নন-বাইনারী",
    "intersex": "উভলিঙ্গতা",
    "transgender": "হিজড়া",
    "gender_fluid": "জেন্ডার ফ্লুইড",
    "not_applicable": "প্রযোজ্য নয়"
  },
  "ethnicity": {
    "american_indian_alaska_native": "আমেরিকান ইন্ডিয়ান বা আলাস্কা্র অধিবাসি ",
    "american_indian_central_america": "দক্ষিণ বা মধ্য আমেরিকা থেকে আমেরিকান ইন্ডিয়ান",
    "asian": "এশিয়ান",
    "black": "নিগ্র বা আফ্রিকান আমেরিকান",
    "latinx": "ল্যাটিনো, ল্যাটিনক্স বা হিস্পানিক",
    "middle_eastern_north_african": "মধ্য প্রাচ্য বা উত্তর আফ্রিকান",
    "native_hawaiian_pacific_islander": "নেটিভ হাওয়াইয়ান বা প্যাসিফিক দ্বীপপুঞ্জ",
    "white_european": "শ্বেতাঙ্গ বা ককেশীয়",
    "unknown": "অজানা",
    "prefer_not_to_disclose": "প্রকাশ করতে অনিচ্ছুক ",
    "asian_indian": "এশিয়ান ইন্ডিয়ান ",
    "filipino": "ফিলিপিনো",
    "japanese": "জাপানি",
    "korean": "কোরিয়ান",
    "vietnamese": "ভিয়েতনামী",
    "other_asian": "অন্যান্য এশিয়ান",
    "native_hawaiian": "স্থানীয় হাওয়াইয়ান",
    "guamanian_or_chamorro": "গুয়ামানিয়ান বা চামোরো",
    "samoan": "সামোয়ান",
    "other_pacific_islander": "অন্যান্য প্রশান্ত মহাসাগরীয় দ্বীপপুঞ্জ",
    "chinese": "চীনা",
    "help": "বর্ণ বলতে বোঝায় শারীরিক বৈশিষ্ট্যগুলির একটি সেট যা মানুষের গোষ্ঠীর মধ্যে পার্থক্য করতে ব্যবহৃত হয়। জাতি জাতীয়তা, অথবা যে দেশে আপনার নাগরিকত্ব আছে সেই দেশের জাতি হতে পারে বা নাও হতে পারে।",
    "subtitle": "প্রবিধানের জন্য প্রয়োজনীয় যেগুলো আমরা নিম্নলিখিত সমস্ত তথ্য সংগ্রহ করি।",
    "laotian": "লাওটিয়ান",
    "cambodian": "কম্বোডিয়ান",
    "other": "অন্যান্য",
    "bangladeshi": "বাঙালি",
    "hmong": "হমং",
    "indonesian": "ইন্দোনেশীয়",
    "malaysian": "মালয়েশীয়",
    "pakistani": "পাকিস্তানি",
    "sri_lankan": "শ্রীলঙ্কান",
    "thai": "থাই",
    "taiwanese": "তাইওয়ানিজ",
    "fijian": "ফিজিয়ান",
    "guamanian": "গুয়ামিয়ান",
    "tongan": "টঙ্গান",
    "bahamian": "বাহামিয়ান"
  },
  "languages": {
    "en": "ইংরেজি",
    "fr": "ফ্রান্স ",
    "es": "স্প্যানিশ ",
    "so": "সোমালি",
    "hmn": "হমং",
    "asl": "আমেরিকান সাইন ল্যাঙ্গুয়েজ (এএসএল)",
    "kar": "কারেন",
    "am": "আমহারিক",
    "ru": "রাশিয়ান ",
    "om": "ওরোমো"
  },
  "symptoms": {
    "fever": "জ্বর বা ঠান্ডা লাগা",
    "cough": "কাশি",
    "muscle_aches": "পেশীতে ব্যথা ",
    "severe_fatigue": "তীব্র ক্লান্তি (স্বাভাবিকের চেয়ে বেশি)",
    "trouble_breathing": "শ্বাস নিতে সমস্যা",
    "diarrhea": "ডায়রিয়া",
    "loss_of_smell": "ঘ্রাণ শক্তি হারানো ",
    "loss_of_taste": "অরুচী বোধ ",
    "shortness_of_breath": "শ্বাসকষ্ট",
    "headache": "মাথাব্যথা",
    "sore_throat": "গলা ব্যথা",
    "congestion": "কনজেশন বা নাক দিয়ে পানি পড়া",
    "nausea": "বমি বমি ভাব বা বমি",
    "close_contact": "সংক্রমিত ব্যক্তির সাথে ঘনিষ্ঠ যোগাযোগ*",
    "helper_text": {
      "close_contact": "*আপনি কি কোভিড -১৯ এ আক্রান্ত এমন ব্যক্তির সাথে কোন রকম ঘনিষ্ঠ যোগাযোগ করেছেন সে বিষয়ে নিশ্চিত(কমপক্ষে ১৫ মিনিটের জন্য ৬ ফুট ব্যবধানের মধ্যে)?"
    },
    "suspected_exposure": "সন্দেহজনক এক্সপোজার",
    "none": "কোন উপসর্গ নেই"
  },
  "instructions": {
    "title": "আপনি নথিভুক্ত কিন্তু আপনি যাওয়ার পূর্বে ...",
    "p1": "এই পৃষ্ঠায় আপনার অ্যাপয়েন্টমেন্টের পাশাপাশি আপনার অ্যাপয়েন্টমেন্ট বারকোড সম্পর্কিত তথ্য রয়েছে।",
    "appointment_scheduled": "আপনার অ্যাপয়েন্টমেন্ট নির্ধারিত",
    "verify_info": {
      "title": "আপনার তথ্য যাচাই করুন",
      "p1": "আপনার যোগাযোগের তথ্য যাচাই করা গুরুত্বপূর্ণ যাতে আপনি দ্রুত আপনার রোগীর পোর্টালে প্রবেশ করতে পারেন।",
      "p2": "একটি নিশ্চিতকরণ ইমেইল আপনাকে পাঠানো হয়েছে। অনুগ্রহপূর্বক প্রদত্ত লিঙ্কে ক্লিক করুন।",
      "p3": "আপনার যোগাযোগের তথ্য পরিবর্তন করার প্রয়োজন হলে, অনুগ্রহপূর্বক সাহায্য বোতাম টিপুন।"
    },
    "verified": "যাচাই্কৃত ",
    "not_verified": "যাচাইকৃত নয় ",
    "resend_text": "লিঙ্কটি পাননি?",
    "resend": "আবার পাঠান",
    "skip": "যাচাইকরণ এড়িয়ে যান এবং কনফার্মেশন দেখান",
    "name": "নাম",
    "appointment_details": "অ্যাপয়েন্টমেন্ট",
    "date_and_time": "তারিখ এবং সময়",
    "add_to_calendar": "ক্যালেন্ডারে যোগ করুন",
    "instructions": "সাধারণ নির্দেশনা",
    "successfully_flash": "সফলভাবে অ্যাপয়েন্টমেন্ট তৈরি করা হয়েছে!",
    "success_flash_email": "সফলভাবে যাচাইকৃত ইমেইল ",
    "success_flash_phone": "ফোন নম্বর সফলভাবে যাচাই করা হয়েছে",
    "mail_order": "আপনি সপ্তাহের মধ্যে মেইলে আপনার টেস্ট-কিট পাবেন।",
    "at_home": "এই সময়ে আপনার বাড়িতে একজন চিকিৎসা প্রদানকারী যাবে ",
    "at_home_instructions": "বাড়িতে নির্দেশাবলী",
    "mail_order_instructions": "মেইল অর্ডার নির্দেশাবলী",
    "request_additional_appointment": "ফলো-আপ অ্যাপয়েন্টমেন্ট বুক করুন",
    "book_additional_appointment": "আরেকটি অ্যাপয়েন্টমেন্ট বুক করুন",
    "confirmation_code": "নিশ্চিতকরণ কোড",
    "completed": "সম্পন্ন ",
    "appointment_barcode": "অ্যাপয়েন্টমেন্ট বারকোড",
    "dependent_links": "গৃহস্থালি অ্যাপয়েন্টমেন্ট লিঙ্ক",
    "on_demand_title": "আপনি নথিভুক্ত কিন্তু আপনি যাওয়ার আগে ...",
    "save_link": "এই লিঙ্কটি সংরক্ষণ করুন",
    "verify_phone": "আপনার ফোন নম্বর যাচাই করুন",
    "verify_phone_description": "আপনার যোগাযোগের তথ্য যাচাই করা গুরুত্বপূর্ণ যাতে আপনি দ্রুত আপনার রেকর্ডগুলিতে অ্যাক্সেস করতে পারেন। আপনার নম্বরে একটি ভেরিফিকেশন টেক্সট মেসেজ পাঠানো হয়েছে।",
    "verify_email_description": "আপনার যোগাযোগের তথ্য যাচাই করা গুরুত্বপূর্ণ যাতে আপনি দ্রুত আপনার রেকর্ডগুলি অ্যাক্সেস করতে পারেন। আপনার ইমেইলে একটি যাচাইকরণ মেইল পাঠানো হয়েছে।",
    "information": "নিবন্ধন সম্পর্কিত তথ্য",
    "follow_up_appointment": "ফলো আপ অ্যাপয়েন্টমেন্ট",
    "get_directions": "দিকনির্দেশ প্রাপ্তি ",
    "cancel": "অ্যাপয়েন্টমেন্ট বাতিল করুন",
    "reschedule_appointment": "পুনরায় অ্যাপয়েন্টমেন্টের সময় নির্ধারন করুন ",
    "reschedule_linked_appointments": "পুনরায় অ্যাপয়েন্টমেন্টসমূহের সময় নির্ধারন করুন ",
    "no_slots": "আর কোনো সময় পাওয়া যাবে না ",
    "check_results": "রোগীর পোর্টাল চেক করুন",
    "follow_up_modal_header": "অনুগ্রহপূর্বক আপনার ২য় ডোজের সময় নির্ধারণ করুন",
    "are_you_sure_you_want_to_cancel": "আপনি কি এই অ্যাপয়েন্টমেন্ট বাতিল করার ব্যাপারে নিশ্চিত?",
    "please_choose_cancellation_reason": "অনুগ্রহপূর্বক নীচে একটি বাতিল করার কারণ নির্বাচন করুন",
    "additional_details": "অনুগ্রহপূর্বক নীচে কোন অতিরিক্ত বিবরণ যোগ করুন",
    "errors": {
      "missing_cancellation_reason": "বাতিল করার কারণ বেছে নিন"
    },
    "verify_email": "আপনার ইমেইল যাচাই করুন",
    "redcap_url": "আপনার জরিপ সম্পন্ন করতে ক্লিক করুন",
    "verify_contact_information": "আপনার যোগাযোগের তথ্য যাচাই করুন",
    "please_also": "অনুগ্রহ করে আরও ",
    "new_title": "{{name}} এর জন্য সুনিশ্চিত করা হচ্ছে",
    "contact_method": "যোগাযোগের মাধ্যম",
    "next_steps": {
      "title": "পরবর্তী পদক্ষেপ",
      "p1": "আপনাকে একটি টেস্ট কিট অ্যাক্টিভেট করতে হবে। আপনি টেস্ট নেওয়ার জন্য প্রস্তুত হলে আপনার ই মেল এ পাঠানো লিংকটির মাধ্যমে এই পেজ এ এসে আপনার কিট টি অ্যাক্টিভেট করুন।",
      "administered": "We will contact you when your kit reaches the lab and when your results are ready. Results typically take 24-48 hours after they reach the lab. You can view results from your [Medical history]({{link}}) page when they are ready.",
      "resulted": "টেস্ট এর ফলাফল আপনার [চিকিৎসার ইতিহাস] ({{link}}) পেজ এ পাওয়া যাবে।",
      "shipping_information": "শিপিং বিবরণ"
    },
    "save_this_page": {
      "title": "পেজটি সেভ করুন",
      "p1": "কোনো সেল্ফ টেস্ট সম্পর্কে জানাতে বা টেস্ট এর ফলাফল জানতে এই পেজে যান।",
      "p2": "আমার বারকোড দেখান",
      "p3": "ভবিষ্যতে এই পেজটি ব্যবহার করতে নিশ্চিতকরণ ই মেল বা এস এম এস এ থাকা লিংকটি খুলুন।"
    },
    "show_my_barcode": "আপনি বুকমার্ক করে, হোম স্ক্রিনে এনে রেখে, বা লিংকটি কপি করে এই পেজটি সেভ করে রাখতে পারেন।",
    "my_account": "আমার অ্যাকাউন্ট",
    "register_another": "আরেকজন অংশগ্রহণকারীকে নিবন্ধিত করুন",
    "update_vaccine": "ভ্যাকসিন সম্পর্কিত তথ্য আপডেট করুন",
    "medical_history": "চিকিৎসার ইতিহাস",
    "upcoming_appointments": "আসন্ন অ্যাপয়েন্টমেন্ট",
    "reschedule": "সময় পুনঃনির্ধারণ",
    "resend_confirmation": "পুনরায় নিশ্চিত করুন",
    "appointment_details_v2": "অ্যাপয়েন্টমেন্ট সংক্রান্ত তথ্য",
    "confirm_cancellation": "বাতিল নিশ্চিত করুন",
    "confirm_cancellation_question": "আপনি কি এই অ্যাপয়েন্টমেন্টটি বাতিল করতে চান?",
    "select_new_appointment_time_below": "নীচের থেকে একটি নতুন অ্যাপয়েন্টমেন্টের সময় নির্বাচন করুন। যদি আপনি অ্যাপয়েন্টমেন্টের পরিসেবা বা স্থান পরিবর্তন করতে চান, এই অ্যাপয়েন্টমেন্টটি বাতিল করে নতুন একটি নিন।",
    "no_take_me_back": "না। আমাকে ফেরত নিয়ে যান",
    "yes_cancel_appointment": "হ্যাঁ। অ্যাপয়েন্টমেন্ট বাতিল করুন",
    "update_appointment": "অ্যাপয়েন্টমেন্ট আপডেট করুন",
    "select_new_appointment_time": "অ্যাপয়েন্টমেন্টের নতুন সময় নির্বাচিত করূন",
    "clinic": "ক্লিনিক",
    "services": "পরিসেবা",
    "appointment_missed": "অ্যাপয়েন্টমেন্ট মিস্ হয়েছে",
    "appointment_canceled": "অ্যাপয়েন্টমেন্ট বাতিল হয়েছে",
    "screening_complete_for": "Screening complete for {{name}}"
  },
  "result_page": {
    "errors": {
      "invalid_access_code": "অ্যাক্সেস কোড বৈধ নয়"
    },
    "landing": {
      "p1": "আপনার ফলাফল দেখতে, অনুগ্রহপূর্বক লিখুন:",
      "access_code_label": "অ্যাক্সেস কোড",
      "submit_button": "জমা দিন",
      "recent_results": "আপনার সাম্প্রতিক ফলাফল"
    },
    "view_results": {
      "headline": "{{name}} এর পরীক্ষার ফলাফল",
      "reregister": "পুনরায় নিবন্ধন করুন",
      "status": {
        "likely_positive": "ফলাফল অনির্দিষ্ট",
        "test_not_performed": "পুনরায় পরীক্ষা প্রয়োজন",
        "results_ready": "ফলাফল প্রস্তুত",
        "processing": "প্রক্রিয়াধীন",
        "test_status": "পরীক্ষার অবস্থা",
        "test_result": "পরীক্ষার ফলাফল",
        "administered": "পরিচালিত",
        "results_pending": "ফলাফল এখনও বেরোয়নি",
        "test_results": "টেস্টের ফলাফল"
      },
      "at": "{{address}} এ"
    },
    "result_label": "ফলাফল",
    "result": {
      "flu_a": {
        "result_label": "ফ্লু A এর ফলাফল"
      },
      "flu_b": {
        "result_label": "ফ্লু B এর ফলাফল"
      },
      "covid19": {
        "result_label": "কোভিড-১৯ এর ফলাফল"
      },
      "covid": {
        "result_label": "কোভিড-১৯ এর ফলাফল"
      },
      "sars": {
        "result_label": "সার্স (SARS) এর ফলাফল"
      },
      "control": {
        "result_label": "নিয়ন্ত্রণ"
      },
      "rsv": {
        "result_label": "RSV ফলাফল"
      },
      "result": {
        "result_label": "ফলাফল"
      },
      "hba1c": {
        "normal": "স্বাভাবিক",
        "warning": "প্রিডায়াবেটিস",
        "danger": "ডায়াবেটিস"
      },
      "lead_venous": {
        "danger": "অস্বাভাবিক",
        "normal": "স্বাভাবিক"
      },
      "tc": {
        "result_label": "TC-র ফলাফল"
      },
      "hdl": {
        "result_label": "HDL-র ফলাফল"
      },
      "trg": {
        "result_label": "TRG-র ফলাফল"
      },
      "ldl": {
        "result_label": "LDL-র ফলাফল"
      },
      "non_hdl": {
        "result_label": "Non-HDL-র ফলাফল"
      },
      "tc_hdl_ratio": {
        "result_label": "TC/HDL অনুপাত"
      },
      "glu": {
        "result_label": "GLU-র ফলাফল"
      },
      "alere_cholestech_ldx": {
        "danger": "ঝুঁকি আছে",
        "warning": "অস্বাভাবিক",
        "normal": "স্বাভাবিক"
      },
      "lead": {
        "result_label": "সীসা"
      },
      "zinc": {
        "result_label": "দস্তা"
      },
      "lead_standard_profile": {
        "danger": "অস্বাভাবিক",
        "normal": "স্বাভাবিক"
      },
      "creatinine": {
        "danger": "অস্বাভাবিক",
        "normal": "স্বাভাবিক"
      },
      "igg": {
        "result_label": "আই জি এম ফলাফল"
      },
      "igm": {
        "result_label": "আই জি এম ফলাফল"
      },
      "blood_glucose_fasted": {
        "normal": "স্বাভাবিক",
        "warning": "উচ্চ",
        "danger": "উচ্চ",
        "hypoglycemia": "হাইপোগ্লাইসেমিয়া",
        "prediabetes": "প্রিডায়াবেটিস",
        "diabetes": "ডায়াবেটিস"
      },
      "total_cholesterol_fasted": {
        "normal": "স্বাভাবিক",
        "elevated": "উচ্চ",
        "high": "উচ্চ",
        "low": "কম",
        "abnormal": "অস্বাভাবিক"
      },
      "total_cholesterol_unfasted": {
        "normal": "স্বাভাবিক",
        "elevated": "উচ্চ",
        "high": "উচ্চ"
      },
      "a1c_now": {
        "normal": "স্বাভাবিক",
        "warning": "ডায়াবেটিসের আগে",
        "danger": "ডায়াবেটিস"
      },
      "blood_glucose": {
        "warning": "কম",
        "normal": "স্বাভাবিক",
        "prediabetes": "প্রিডায়াবেটিস",
        "danger": "ডায়াবেটিস",
        "hypoglycemia": "হাইপোগ্লাইসেমিয়া",
        "medical_emergency": "চিকিৎসা জরুরি অবস্থা",
        "inconclusive_1": "অসম্পূর্ণ 1",
        "inconclusive_2": "অসম্পূর্ণ 2",
        "possible_diabetes": "সম্ভাব্য ডায়াবেটিস"
      },
      "triglycerides": {
        "result_label": "ট্রাইগ্লিসারাইড"
      },
      "blood_glucose_ucsf": {
        "low": "কম",
        "normal": "স্বাভাবিক",
        "high": "উচ্চ"
      },
      "syphilis": {
        "result_label": "সিফিলিস ফলাফল"
      },
      "hepatitis_c": {
        "result_label": "হেপাটাইটিস সি ফলাফল"
      },
      "hiv": {
        "result_label": "এইচআইভি ফলাফল"
      },
      "rapid_hiv": {
        "positive": "প্রতিক্রিয়াশীল (প্রাথমিক ইতিবাচক)",
        "negative": "প্রতিক্রিয়াশীল নয় (নেতিবাচক)",
        "did_not_result": "অকার্যকর (অনির্ধারিত)"
      },
      "rapid_hcv": {
        "positive": "প্রতিক্রিয়াশীল (প্রাথমিক ইতিবাচক)",
        "negative": "প্রতিক্রিয়াশীল নয় (নেতিবাচক)",
        "did_not_result": "অকার্যকর (অনির্ধারিত)"
      },
      "rapid_syphilis": {
        "positive": "প্রতিক্রিয়াশীল (প্রাথমিক ইতিবাচক)",
        "negative": "প্রতিক্রিয়াশীল নয় (নেতিবাচক)",
        "did_not_result": "অকার্যকর (অনির্ধারিত)"
      }
    },
    "documents": "নথিপত্র",
    "self_administered": "স্ব-শাসিত পরীক্ষা {{location}} এ নেওয়া হয়েছে",
    "patient": "রোগী",
    "medical_history": "চিকিৎসার ইতিহাস",
    "overview_title": "কোনো টেস্ট বা পরিসেবা সম্বন্ধে বিশদে জানতে ঐ টেস্ট বা পরিসেবা টি নির্বাচিত করুন। বিঃ দ্রঃ কিছু টেস্ট এর ফলাফল শুধুমাত্র প্রদানকারীর সাথে কথা বলার পরই পাওয়া যাবে।",
    "insurance_information": "ইনসিওরেন্স এর তথ্য প্রদান করুন",
    "contact_support": "কোনোরকম সহায়তার প্রয়োজন হলে আমাদের সাথে যোগাযোগ করুন।",
    "show": "দেখান",
    "hide": "হাইড করুন",
    "lab_report": "ল্যাবের ফলাফল",
    "contact_provider": {
      "header": "আপনার ফলাফল ইতিবাচক",
      "description": "আপনি কি আপনার টেস্ট এর ফলাফল বা চিকিৎসা সম্বন্ধে পরামর্শের জন্য আমাদের প্রদানকারীর সাথে কথা বলতে চান?",
      "yes_option_text": "হ্যাঁ, আমি একজন প্রদানকারীর সাথে কথা বলতে চাই",
      "no_option_text": "না, আমি আমার টেস্ট এর ফলাফল নিজেই বুঝতে পারবো, আমি কোনো প্রদানকারীর সাথে কথা বলতে চাইনা",
      "confirm_phone_number_header": "আপনার ফোন নম্বর সুনিশ্চিত করুন",
      "confirm_phone_number_description": "আপনার সাথে যোগাযোগের জন্য সবচেয়ে উপযোগী ফোন নম্বরটি সুনিশ্চিত করূন।",
      "confirm_button_text": "সুনিশ্চিত করুন",
      "consultation_confirmed_header": "পরামর্শ সুনিশ্চিত করা হল",
      "consultation_confirmed_description": "2-3 টি ব্যবসায়িক দিবসের মধ্যে আমাদের একজন প্রদানকারী আপনার ফোন নম্বর {{phone_number}} এ যোগাযোগ করে নেবে।",
      "acknowledgement_option_helper_text": "এমন কিছু যা চিকিৎসার গুরুত্ব ব্যাখ্যা করে এবং ব্যবহারকারীরা তাদের মন পরিবর্তন করলে কীভাবে ফোন করা যায় তা জানায়।",
      "acknowledgement_confirmed_header": "স্বীকৃতি সুনিশ্চিত করা হয়েছে",
      "acknowledgement_confirmed_description": "লিঙ্কে উল্লেখিত সংস্থানগুলির সাথে চিকিৎসা পাওয়ার গুরুত্ব সম্পর্কে কিছু তথ্য:  প্রদানকারীর পরামর্শ সম্পূর্ণ বিনামূল্যে দেওয়া হয় এবং প্রদানকারী সংক্রমণ সমাধানে সাহায্য করতে যেকোনো কিছু প্রেস্ক্রাইব করতে পারেন।",
      "acknowledgement_confirmed_change_mind_text": "আপনি যদি আপনার মত পরিবর্তন করে থাকেন তবে, \"আমি পরামর্শ চাই\" নির্বাচন করুন।",
      "request_consultation_button_text": "আমি পরামর্শ চাই"
    },
    "phone": "ফোন",
    "source": "Source"
  },
  "required": {
    "errors": {
      "address_not_in_bounding_box": "আপনার ঠিকানা এই প্রোগ্রামের সাইটগুলির শর্তের সাথে মেলে না।"
    }
  },
  "member": {
    "medical_history": "পূর্ব তথ্য",
    "view_instructions": "নিশ্চয়তা দেখুন",
    "next_appointment": "পরবর্তী অ্যাপয়েন্টমেন্ট",
    "over_18": "আমি প্রত্যয়ন করছি যে আমার বয়স ১৮ বছর বা তার বেশি",
    "choose_test_configurations_title": "এই অ্যাপয়েন্টমেন্টের জন্য অনুগ্রহ করে আপনি যে পরিষেবাগুলি চান তা নির্বাচন করুন",
    "member_taken_error": "ব্যবহারকারীর ইতিমধ্যেই একটি অ্যাকাউন্ট আছে",
    "choose_test_configurations_subtitle": "পরিষেবা (গুলি) পরিবারের সকল সদস্যদের জন্য প্রযোজ্য হবে",
    "service": "সেবা",
    "group_or_location": "গ্রুপ/অবস্থান",
    "details": "বিস্তারিত",
    "see_all": "সব দেখুন",
    "no_history": "এই মুহূর্তে কোন ইতিহাস পাওয়া যায় না।",
    "medical_history_title_with_name": "{{name}} এর পূর্ব তথ্য",
    "no_dashboard": "এই মুহূর্তে আর কিছু পাওয়া যাচ্ছে না",
    "product": "পণ্য",
    "price": "মূল্য",
    "quantity": "পরিমাণ",
    "total_services_selected": "নির্বাচিত সেবাসমূহ",
    "total_price": "মোট মূল্য"
  },
  "or": "অথবা",
  "account": {
    "errors": {
      "must_be_13": "একটি অ্যাকাউন্টে নিবন্ধনের জন্য ১৩ বছর বয়সী হতে হবে"
    }
  },
  "self_administration": {
    "title": "স্ব-শাসন ",
    "self_administer_action": "স্ব-শাসক ",
    "skip_to_link": "স্ব-শাসন এড়িয়ে যান",
    "select_person": "চেক আউট করার জন্য একজন ব্যক্তি নির্বাচন করুন",
    "adult": "প্রাপ্তবয়স্ক",
    "child": "শিশু",
    "checked_out": "চেক আউট",
    "go_back": "পিছনে যান",
    "switch_to_scanner": "স্ক্যানারে পরিবর্তন করুন",
    "enter_barcode": "বারকোডের মান লিখুন",
    "scan_barcode": "বারকোড স্ক্যান করুন",
    "cancel": "বাদ করুন ",
    "barcode_for": "{{stuff}} এর জন্য বারকোড",
    "enter_barcode_manually": "হাতে করে বারকোডের মান লিখুন",
    "instructions": "আপনার টেস্ট টিউবের গায়ে লিখিত বারকোডটি স্ক্যান করুন অথবা তার মান নিচে লিখুন",
    "regex_prefix": "বারকোডে অবশ্যই থাকতে হবে {{stuff}}",
    "all_completed": "সম্পন্নঃ বাড়ির সকলে এই ধাপটি শেষ করেছেন",
    "errors": {
      "no_appointment": "অ্যাপয়েন্টমেন্ট খুঁজে পেতে সমস্যা হচ্ছে",
      "barcode_in_use": "এই বারকোডটি পূর্বে ব্যবহৃত হয়েছে। আপনি যদি পূর্বে একা এই টেস্ট কীটটি ব্যবহার না করে থাকেন, তবে যেখান থেকে এই কীটটি পেয়েছেন, সেখানে গিয়ে একটি নতুন কীট অনুরোধ করুন। অন্যথায়, নিচের সাহায্য বাটনটি চাপুন। ",
      "test_error_general": "টেস্টটি তৈরি করতে সমস্যা হচ্ছে ",
      "different_barcodes": "আপনি যেই বারকোডগুলোর মান লিখেছেন তারা একই নয়। "
    },
    "confirm_barcode_input": "নিশ্চিত করার জন্য আবার বারকোডটির মান লিখুন",
    "click_to_self_test": "নিজে টেস্টটি করতে চাইলে এখানে ক্লিক করুন",
    "or_enter_barcode_manually": "Or enter manually with all letters and numbers"
  },
  "location_details": {
    "next_appointment": {
      "waitlist": "অপেক্ষমান তালিকা",
      "unavailable": "কোন অ্যাপয়েন্টমেন্ট পাওয়া যায় না"
    },
    "labels": {
      "address": "ঠিকানা",
      "next_appointment": "পরবর্তী অ্যাপয়েন্টমেন্টের এভেইলেবল সময় ",
      "services": "পরিষেবা আছে "
    }
  },
  "waiting_room": {
    "header": "আপনি ওয়েটিং রুমে আছেন; অনুগ্রহ করে অপেক্ষা করুন ততক্ষন পর্যন্ত যখন আমরা আপনাকে শিডিউলিং সিস্টেমের সাথে সংযুক্ত করি।",
    "p1": "দয়া করে ধৈর্য ধরুন. আমরা একসাথে এই মহামারীটি শেষ করব।",
    "signature": "আন্তরিকভাবে",
    "p2": "আমরা জানি কোভিড -১৯ এর অভিজ্ঞতা হতাশাজনক হতে পারে। আপনার অ্যাপয়েন্টমেন্ট বুক করার জন্য আমরা যত দ্রুত সম্ভব কাজ করছি এবং ততক্ষণ পর্যন্ত আপনি এখানে অপেক্ষা করুন।"
  },
  "users": {
    "send_appointment_confirmation_message": "হ্যালো, {{full_name}}। {{name}} তে আপনার অ্যাপয়েন্টমেন্টের জন্য এটি একটি রিমান্ডার। আপনার অ্যাপয়েন্টমেন্ট {{date}} তারিখে {{time}} টায় {{address}} এ।",
    "send_registration_link": "হ্যালো, {{full_name}}। আপনার {{name}} {{registration_link}} এর জন্য নিবন্ধন করতে এই লিঙ্কটি অনুসরণ করুন"
  },
  "follow_up": {
    "first_dose": "প্রথম ডোজ",
    "previous_appointment": "অতীতের অ্যাপয়েন্টমেন্ট",
    "booked_appointment": "আপনার অ্যাপয়েন্টমেন্ট",
    "second_dose": "দ্বিতীয় ডোজ",
    "choose_second_location": "দ্বিতীয় অ্যাপয়েন্টমেন্ট একটি লোকেশন বেনির্বাচন করুন "
  },
  "cancellation_types": {
    "cant_get_to_location": "আমার একটা টাইমিং কনফ্লিক্ট ছিল",
    "timing_conflict": "আমি কোভিড-১৯ এ আক্রান্ত হয়ে অসুস্থ হয়ে পড়েছি",
    "became_ill_with_covid19": "আমি এই পরিষেবা অন্য কোথাও পেয়েছি",
    "received_service_elsewhere": "অন্যান্য",
    "other": "পরিবর্তে নাম টাইপ করুন",
    "duplicate_appointment": "এই অ্যাপয়েন্টমেন্টটি ইতিমধ্যে একবার করা হয়েছিল"
  },
  "translation": {
    "consent": {
      "type_name_instead": "নাম টাইপ করুন",
      "type_name": "বদলে আপনার সইটি টাইপ করতেও পারেন"
    }
  },
  "email": {
    "confirmation": {
      "your_access_code_is": "আপনার অ্যাক্সেস কোড হল",
      "please_confirm_your_email": "অনুগ্রহ করে নীচের বোতামে ক্লিক করে আপনার ইমেইল নিশ্চিত করুন",
      "hello": "হ্যালো",
      "click_to_reschedule": "নির্দেশাবলী দেখার জন্য ক্লিক করুন/পুনঃনির্ধারণ করুন",
      "click_to_reschedule_on_demand": "নির্দেশাবলী দেখাতে ক্লিক করুন"
    },
    "cancellation": {
      "your_appointment_has_been_canceled": "আপনার অ্যাপয়েন্টমেন্ট {{place}} স্থানে {{time}} টার জন্য বাতিল করা হয়েছে। যদি কোনো ভুল হয়ে থাকে তবে support@primary.health এ যোগাযোগ করূন"
    }
  },
  "signature_lines": {
    "name": "অংশগ্রহণকারীর নাম",
    "date": "তারিখ",
    "signature": "অংশগ্রহণকারীর স্বাক্ষর",
    "and_or": "এবং/অথবা",
    "guardian_name": "পিতামাতা/অভিভাবকের নাম",
    "guardian_signature": "পিতামাতা/অভিভাবকের স্বাক্ষর"
  },
  "employer_testing": {
    "hello_name": "হ্যালো {{name}}",
    "results": {
      "negative": "নেগেটিভ ",
      "positive": "পজিটিভ ",
      "did_not_result": "অজানা",
      "unknown": "অজানা",
      "invalid": "অকার্যকর",
      "pending": "অমীমাংসিত"
    },
    "code_reader": {
      "scan_your_code": "আপনার পরীক্ষার কার্ডের কোডটি স্ক্যান করুন",
      "find_in_top_right_hand_corner": "স্ক্যান কোডটি আপনার পরীক্ষার জন্য ইউনিক এবং আপনার পরীক্ষার উপরের ডান দিকের কোণায় পাওয়া যাবে",
      "center_code": "কোডটি এখানে কেন্দ্র করুন।",
      "already_used_error": "এই পরীক্ষার বারকোড ইতিমধ্যেই ব্যবহার করা হয়েছে। সহায়তার জন্য অনুগ্রহ করে আপনার টেস্ট কিট প্রদানকারীর সাথে যোগাযোগ করুন।",
      "click_to_scan": "কিউআর কোড স্ক্যান করতে ক্লিক করুন",
      "scan_new_test_card": "একটি নতুন পরীক্ষার কার্ড স্ক্যান করতে এখানে ক্লিক করুন।",
      "not_working": "কাজ করছে না?",
      "try_again": "আবার চেষ্টা করতে এখানে ক্লিক করুন।"
    },
    "continue": "চালিয়ে যান",
    "verify_date_of_birth": {
      "confirm_date_of_birth": "অনুগ্রহ করে চালিয়ে যাওয়ার জন্য অংশগ্রহণকারীর জন্ম তারিখ নিশ্চিত করুন",
      "contact_administrator": "যদি প্রদর্শিত তথ্য ভুল হয়, অনুগ্রহ করে সাহায্যের জন্য একজন প্রশাসকের সাথে যোগাযোগ করুন",
      "error": "প্রবেশ করা জন্ম তারিখ ভুল - অনুগ্রহ করে আবার চেষ্টা করুন অথবা এটি আপডেট করার জন্য আপনার সাইট প্রশাসকের সাথে যোগাযোগ করুন।"
    },
    "result_entry": {
      "code_is_registered": "আপনার কোড নিবন্ধিত।",
      "take_the_test": "পরীক্ষা দিন ",
      "follow_the_instructions": "আপনার পরীক্ষার সাথে আসা নির্দেশাবলী অনুসরণ করুন এবং পরীক্ষার কার্ডের শিশিতে নাকে সোয়াব প্রবেশ করার পরে আপনার ১৫ মিনিটের টাইমার শুরু করুন।",
      "cant_find_instructions": "নির্দেশনা খুঁজে পাচ্ছেন না?",
      "view_instructions": "এখন বিনাক্স নির্দেশাবলী দেখুন",
      "start_timer": "১৫ মিনিট টাইমার শুরু (ঐচ্ছিক)",
      "submit_within_15": "পরামর্শ: ১৫ মিনিটের মধ্যে আপনার ফলাফল জমা দিন",
      "enter_test_results": "পরীক্ষার ফলাফল লিখুন",
      "choose_a_result": "আপনার পরীক্ষার কার্ডের ফলাফল বর্ণনা করে এমন বিকল্পটি নির্বাচন করুন",
      "submit": "জমা দিন",
      "must_log_result_and_photo": "চালিয়ে যাওয়ার জন্য আপনাকে অবশ্যই একটি ফলাফল লগ করতে হবে এবং আপনার পরীক্ষার একটি ছবি তুলতে হবে",
      "submit_within_15_v2": "পরামর্শঃ পরীক্ষা ১৫ মিনিট চলার পর আপনার ফলাফল জমা দিন",
      "click_to_take_photo": "ছবি তুলতে ক্লিক করুন",
      "results_may_be_invalid": "পরীক্ষার ফলাফল বৈধ নাও হতে পারে"
    },
    "summary": {
      "title": "ফলাফলের সারাংশ",
      "negative_subtitle": "আপনার কোভিড -১৯ নেই",
      "negative_message": "আমরা আপনার নিয়োগকর্তাকে একটি বার্তা পাঠিয়েছি যে আপনি অনসাইটে কাজে ফিরে আসার অনুমতি পেয়েছেন।",
      "positive_subtitle": "আমরা আন্তরিকভাবে দুঃখিত যে, আপনার কোভিড -১৯ আছে",
      "positive_message": "আমরা আপনার নিয়োগকর্তাকে একটি বার্তা পাঠিয়েছি যে আপনার কোভিড-১৯ আছে।",
      "what_should_you_do": "তোমার কি করা উচিত:",
      "employer_name_resources": "নিয়োগকর্তার নাম সম্পদ:",
      "follow_cdc_guidelines": "সিডিসির প্রস্তাবিত নির্দেশিকা অনুসরণ করুন"
    },
    "clarifying_results": {
      "title": "আপনার ফলাফল স্পষ্ট করা",
      "which_did_your_result_most_look_like": "আপনার ফলাফলটি সবচেয়ে বেশি কেমন লাগছিল?",
      "no_lines": "কোন লাইন দেখা যায় না",
      "blue_control_line_only": "শুধুমাত্র নীল কন্ট্রোল লাইন",
      "pink_sample_line_only": "শুধুমাত্র গোলাপী নমুনা লাইন",
      "blue_control_line_and_pink_sample_line": "নীল নিয়ন্ত্রণ লাইন এবং গোলাপী/বেগুনি নমুনা লাইন",
      "still_not_sure": "এখনও নিশ্চিত নই",
      "submit_results": "ফলাফল জমা দিন",
      "thank_you": "আপনাকে ধন্যবাদ!",
      "clarification_received_message": "আপনার ফলাফলের ব্যাখ্যা পাওয়া গেছে।",
      "only_pink_line": "শুধু গোলাপি রঙের দাগ",
      "no_lines_v2": "কোন দাগ নেই"
    },
    "return_to_confirmation": "নিশ্চিতকরণ পৃষ্ঠায় ফিরে যান"
  },
  "preferred_language": {
    "title": "পছন্দের ভাষা",
    "subtitle": "আপনি কোন ভাষা পছন্দ করেন?"
  },
  "appointment_type": {
    "initial_vaccine_appointment": "প্রাথমিক টিকা সিরিজ",
    "one_dose": "একটি নির্দিষ্ট ডোজের জন্য একটি অ্যাপয়েন্টমেন্ট বুক করুন। বিশেষ করে, এটি আমার",
    "title": "ডোজ নির্বাচন",
    "first_dose": "প্রথম ডোজ",
    "second_dose": "দ্বিতীয় ডোজ",
    "single_dose_title": "সিংগেল ডোজ ",
    "additional": "অতিরিক্ত",
    "booster": "বুস্টার",
    "supplemental": "সম্পূরক ডোজ",
    "third_dose": "শুধুমাত্র তৃতীয় ডোজ",
    "no_vaccine": "উপরোক্ত কোনটাই নয়"
  },
  "activemodel": {
    "errors": {
      "models": {
        "importers/results/row": {
          "attributes": {
            "administered_at": {
              "invalid_datetime": "{{datetime_format}} ফর্ম্যাট থাকতে হবে"
            },
            "results_at": {
              "invalid_datetime": "{{datetime_format}} ফর্ম্যাট থাকতে হবে"
            },
            "uid": {
              "unknown_test": "পরীক্ষা পাওয়া যায় নি"
            }
          }
        },
        "importers/participants/row": {
          "attributes": {
            "access_code": {
              "not_allow_update_test_group_user": "ব্যবহারকারী বিদ্যমান এবং এটি আপডেট করার অনুমতি নেই"
            },
            "date_of_birth": {
              "invalid_date": "{{date_format}} ফর্ম্যাট থাকতে হবে"
            },
            "ethnicity": {
              "unknown_ethnicities": {
                "one": "{{unknown_ethnicities}} বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{ethnicities}}",
                "other": "{{unknown_ethnicities}} বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{ethnicities}}"
              }
            },
            "gender": {
              "unknown_gender": "লিঙ্গ বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{genders}}"
            },
            "phone_number": {
              "invalid": "নম্বর বৈধ নয় "
            },
            "population_name": {
              "unknown_population": "{{unknown_population}} বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{population_names}}"
            },
            "self_described_gender": {
              "not_allowed": "লিঙ্গটি \"prefer_to_self_describe\" না হলে এটি পূরণ করতে পারবেন না "
            },
            "sex": {
              "unknown_sex": "লিঙ্গের অস্তিত্ব নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{sexes}}"
            },
            "sexual_orientation": {
              "unknown_sexual_orientation": "sex_orientation বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{sexual_orientations}}"
            },
            "status": {
              "unknown_status": "অবস্থা বৈধ নয়, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{statuses}}"
            },
            "races": {
              "unknown_races": {
                "one": "{{unknown_races}} বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{races}}",
                "other": "{{unknown_races}} বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{races}}"
              }
            },
            "vaccination_status": {
              "unknown_vaccination_status": "vaccination status is invalid, pick from the following acceptable values: {{vaccination_statuses}}"
            }
          }
        },
        "importers/organization_user/row": {
          "attributes": {
            "role": {
              "insufficient_privileges": "ভূমিকা নির্ধারণের জন্য অপর্যাপ্ত সুযোগ -সুবিধা"
            },
            "user_id": {
              "unknown_user": "ব্যবহারকারী খুঁজে পাওয়া যাচ্ছে না "
            }
          }
        },
        "importers/additional_information/row": {
          "attributes": {
            "additional_information": {
              "invalid_json": "জেএসওএন বৈধ নয় "
            },
            "user_id": {
              "unknown_user": "ব্যবহারকারী খুঁজে পাওয়া যাচ্ছে না "
            }
          }
        },
        "importers/emr/row": {
          "attributes": {
            "appointment_location": {
              "unknown_location": "অ্যাপয়েন্টমেন্ট লোকেশন পাওয়া যায়নি"
            },
            "date_of_birth": {
              "invalid_date": "{{date_format}} ফর্ম্যাট থাকতে হবে"
            },
            "email": {
              "duplicated": "ইতিমধ্যে ব্যবহৃত হয়েছে "
            },
            "ethnicity": {
              "unknown_ethnicities": {
                "one": "{{unknown_ethnicities}} বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{ethnicities}}",
                "other": "{{unknown_ethnicities}} বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{ethnicities}}"
              }
            },
            "gender": {
              "unknown_gender": "লিঙ্গ বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{genders}}"
            },
            "phone_number": {
              "invalid": "নম্বর বৈধ নয় "
            },
            "population": {
              "unknown_population": "{{unknown_population}} বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{population_names}}"
            },
            "self_described_gender": {
              "not_allowed": "লিঙ্গটি \"prefer_to_self_describe\" না থাকলে এটি পূরণ করতে পারে না"
            },
            "sex": {
              "unknown_sex": "লিঙ্গের অস্তিত্ব নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{sexes}}"
            },
            "sexual_orientation": {
              "unknown_sexual_orientation": "sex_orientation বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{sexual_orientations}}"
            },
            "races": {
              "unknown_races": {
                "one": "{{unknown_races}} বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{races}}",
                "other": "{{unknown_races}} বিদ্যমান নেই, নিম্নলিখিত গ্রহণযোগ্য মান থেকে বেছে নিন: {{races}}"
              }
            }
          }
        },
        "importers/additional_consents/row": {
          "attributes": {
            "consent_form_id": {
              "unknown_consent_form": "consent_form not found"
            },
            "access_code": {
              "unknown_user": "user not found"
            }
          }
        },
        "importers/vaccine/row": {
          "attributes": {
            "date_of_birth": {
              "invalid_date": "should have format {{date_format}}"
            },
            "phone_number": {
              "invalid": "is an invalid number"
            },
            "email": {
              "duplicated": "is already used"
            },
            "races": {
              "unknown_races": {
                "one": "{{unknown_races}} does not exist, pick from the following acceptable values: {{races}}",
                "other": "{{unknown_races}} do not exist, pick from the following acceptable values: {{races}}"
              }
            },
            "gender": {
              "unknown_gender": "gender does not exist, pick from the following acceptable values: {{genders}}"
            },
            "sexual_orientation": {
              "unknown_sexual_orientation": "sexual_orientation does not exist, pick from the following acceptable values: {{sexual_orientations}}"
            },
            "self_described_gender": {
              "not_allowed": "cannot fill it if the gender is not \"prefer_to_self_describe\""
            },
            "sex": {
              "unknown_sex": "sex does not exist, pick from the following acceptable values: {{sexes}}"
            },
            "ethnicity": {
              "unknown_ethnicities": {
                "one": "{{unknown_ethnicities}} does not exist, pick from the following acceptable values: {{ethnicities}}",
                "other": "{{unknown_ethnicities}} do not exist, pick from the following acceptable values: {{ethnicities}}"
              }
            },
            "tag_action": {
              "unknown": "{{unknown_tag_action}} is an invalid value, pick from the following acceptable values: {{tag_actions}}"
            },
            "population": {
              "unknown_population": "{{unknown_population}} does not exist, pick from the following acceptable values: {{population_names}}"
            },
            "appointment_location": {
              "unknown_location": "appointment location not found"
            },
            "appointment_date": {
              "invalid_date": "should have format {{date_format}}"
            },
            "dose_type": {
              "invalid_dose": "{{unknown_dose}} is not a valid dose, pick from the following acceptable values: {{acceptable_doses}}",
              "unavailable_dose": "{{dose_type}} is not available within the vaccine_lot, pick from the following available values: {{available_doses}}"
            },
            "vis_version_date": {
              "invalid_date": "should have format {{date_format}}"
            }
          }
        },
        "importers/base/row": {
          "attributes": {
            "appointment_time": {
              "invalid_time": "should have format {{time_format}}"
            }
          }
        }
      }
    }
  },
  "activerecord": {
    "errors": {
      "models": {
        "test_location": {
          "attributes": {
            "metadata": {
              "wrong_json": "is not a valid JSON"
            },
            "name": {
              "taken": "এবং ঠিকানা ইতিমধ্যে অন্য একটি বিদ্যমান স্থানে ব্যবহার করা হয়েছে "
            }
          }
        }
      }
    },
    "attributes": {
      "organization_user": {
        "organization_user_leads": {
          "one": "User",
          "other": "Users"
        }
      },
      "appointment_slot_group": {
        "organization_user_leads": {
          "one": "Location",
          "other": "Locations"
        }
      }
    }
  },
  "hispanic_questions": {
    "hispanic": "হিস্পানিক বা ল্যাটিনো/এ ",
    "not_hispanic": "হিস্পানিক বা ল্যাটিনো/এ নয়",
    "hispanic_expanded": {
      "other": "আরেকটি হিস্পানিক, ল্যাটিনো/এ বা স্প্যানিশ বংশোদ্ভূত",
      "mexican": "মেক্সিকান, মেক্সিকান আমেরিকান, চিকানো/এ",
      "puerto_rican": "পুয়ের্তো রিকান",
      "cuban": "কিউবান"
    },
    "subtitle": "প্রবিধানের জন্য অবশ্যই প্রযোজ্য শর্তে আমরা নিম্নলিখিত তথ্য সংগ্রহ করি",
    "help": "জাতিসত্তা বলতে বোঝায় সাধারণ বৈশিষ্ট্যের একটি সেট যেমন ভাষা, সাংস্কৃতিক রীতিনীতি, ধর্ম এবং অন্যান্য বৈশিষ্ট্য যা মানুষের গোষ্ঠীর পার্থক্য করতে ব্যবহৃত হয়। এটি একটি জাতিগত পরিচয়ের সাথে সামঞ্জস্য হতে পারে বা নাও হতে পারে।",
    "unknown": "অজানা",
    "title": "জাতিসত্তা"
  },
  "sex_at_birth": {
    "question": "লিঙ্গ ",
    "female": "নারী ",
    "male": "পুরুষ",
    "help": "লিঙ্গ বলতে আপনার জন্ম সনদে যা আছে তা বোঝায়।",
    "non_binary": "অ-বাইনারি",
    "subtitle": "প্রবিধানের জন্য প্রযোজ্য অবশ্যিক শর্তে আমরা নিম্নলিখিত সমস্ত তথ্য সংগ্রহ করি।",
    "decline": "উত্তর প্রদান করতে অনিচ্ছুক ",
    "unknown": "অজানা"
  },
  "gender": {
    "help": "লিঙ্গ পরিচয় বলতে বোঝায় যে আপনি কিভাবে ব্যক্তিগতভাবে শনাক্ত করেন নিজেকে। এটি আপনার জন্মের সময় নির্ধারিত লিঙ্গের সাথে সামঞ্জস্য হতে পারে বা নাও হতে পারে।",
    "subtitle": "আপনি যদি আপনার লিঙ্গ পরিচয় সম্পর্কে তথ্য যোগ করতে চান তাহলে তা করুন।"
  },
  "sexual_orientation": {
    "title": "যৌন প্রবনতা",
    "subtitle": "আপনি যদি আপনার যৌন প্রবণতা সম্পর্কে তথ্য যোগ করতে চান, দয়া করে তা করুন।",
    "gay": "গে, লেসবিয়ান, বা হোমোসেক্সচুয়াল/সমকামী",
    "heterosexual": "বিষমকামী বা স্ট্রেইট ",
    "bisexual": "উভলিঙ্গ/বাইসেক্সচুয়াল ",
    "questioning": "প্রশ্ন করা/অনিশ্চিত/জানি না",
    "prefer_not_to_disclose": "প্রকাশ না করার জন্য চনির্বাচন করুন ",
    "unknown": "অজানা",
    "orientation_not_listed": "ওরিয়েন্টেশন তালিকাভুক্ত নয়",
    "not_applicable": "প্রযোজ্য নয়",
    "pansexual": "প্যানসেক্সুয়াল",
    "queer": "কুইয়ার"
  },
  "pronouns": {
    "title": "পছন্দের সর্বনাম",
    "he": "সে/তাকে (পুরুষ) ",
    "she": "সে/তাকে (নারী) ",
    "they": "তারা/তাদের ",
    "choose_not_to_disclose": "প্রকাশ না করার জন্য চনির্বাচন করুন ",
    "prefer_to_self_describe": "নিজে নিজে বর্ণনা করতে নির্বাচন করুন "
  },
  "no_insurance_information": {
    "driver_license_or_state_id": "ড্রাইভার লাইসেন্স বা রাষ্ট্রীয় পরিচয়পত্র নম্বর",
    "driver_license": "চালকের লাইসেন্স ",
    "use_ssn_instead": "পরিবর্তে এসএসএন  ব্যবহার করুন",
    "social_security_number": "সামাজিক নিরাপত্তা নম্বর",
    "state": "রাষ্ট্র",
    "upload_front_of_driver_license": "আপনার ড্রাইভার লাইসেন্সটির সামনের দিকটি আপলোড করুন বা স্টেট আইডি নম্বর দিন ",
    "choose_file": "ফাইল নির্বাচন করুন",
    "no_file_chosen": "কোন ফাইল নির্বাচন করা হয়নি",
    "no_identification": "আমার কোন পরিচয়পত্র নেই",
    "insurance_card_has_a_back": "আমার ইনস্যুরেন্স কার্ডটির পেছনের দিক আছে ",
    "upload_front_of_insurance_card": "আপনার ইনস্যুরেন্স কার্ডটির সামনের দিকটি আপলোড করুন।",
    "front_of_insurance_card_uploaded": "আপনার ইনস্যুরেন্স কার্ডটির সামনের দিকটি আপলোড হয়েছে।",
    "insurance_card": "ইনস্যুরেন্স কার্ড",
    "insurance_card_back": "ইনস্যুরেন্স কার্ডটির পেছনের দিক ",
    "back_of_insurance_card_uploaded": "আপনার ইনস্যুরেন্স কার্ডটির পেছনের দিকটি আপলোড হয়েছে।"
  },
  "quidel": {
    "certify_text": "আমি প্রত্যয়ন যে আমি শুধুমাত্র একবার এই পরীক্ষার ফলাফল লগ করছি।",
    "entering_results": "আপনার ফলাফলে প্রবেশ করুন",
    "review_instructions_1": "নির্দেশাবলী সাবধানে পর্যালোচনা করুন",
    "review_instructions_2": "আপনি আপনার পরীক্ষার সাথে আসা নির্দেশাবলী পর্যালোচনা করতে পারেন, ধাপে ধাপে নির্দেশিকা পাঠ করতে পারেন, অথবা নীচে একটি নির্দেশমূলক ভিডিও দেখতে পারেন:",
    "read_instructions": "নির্দেশনা পাঠ করুন ",
    "watch_video": "ভিডিওটি দেখুন",
    "timer": "টিউবে সোয়াব নাড়ানোর পর টাইমার চালু করুন। টাইমার ১ মিনিটের পরে থামবে (আপনার জন্য নল থেকে সোয়াব অপসারণ করার জন্য)। অনুগ্রহ করে মনে রাখবেন: আপনার পরীক্ষার ফলাফলের জন্য ১০  মিনিট শুরু করতে আপনাকে অবশ্যই টাইমার পুনরায় রিজিউম করতে হবে।",
    "start_timer": "টাইমার চালু  করুন (ঐচ্ছিক) ",
    "restart_timer": "থামুন এবং পুনরায় চালু করুন",
    "resume": "থামান ",
    "one_minute_countdown": "১ মিনিট কেটে গেছে! টিউব থেকে আপনার সোয়াব সরান এবং টাইমার পুনরায় চালু করুন।",
    "take_photo": "আপনার টেস্ট স্ট্রিপের ছবি তুলুন",
    "photo_warning": "চালিয়ে যাওয়ার জন্য একটি ফটো প্রদান করা প্রয়োজন।",
    "enter_results": "পরীক্ষার ফলাফল লিখুন",
    "choose_result": "আপনার পরীক্ষার স্ট্রিপটি সবচেয়ে ভালভাবে প্রতিফলিত করে এমন বিকল্পটি নির্বাচন করুন। সাহায্য দরকার? উদাহরণের ফলাফল দেখতে এখানে ক্লিক করুন।",
    "positive": "পজিটিভ ",
    "negative": "নেগেটিভ ",
    "unknown": "অজানা",
    "clarify": "আপনার ফলাফল স্পষ্টকরণ ",
    "strip_question": "আপনার টেস্ট স্ট্রিপে কোনটি সবচেয়ে স্পষ্ট ছিলো?",
    "no_lines": "লাইন নেই",
    "pink_line": "শুধু গোলাপী রেখা",
    "not_sure": "এখনও নিশ্চিত নই"
  },
  "ihealth": {
    "take_a_photo_of_your_test": "ফলাফলের ছবি ",
    "retake_photo": "আবার ছবি তুলুন",
    "capture_photo": "ছবি তুলুন",
    "confirm_information_correct": "আমি নিশ্চিত করছি যে উপরের সকল তথ্য সঠিক।",
    "submit": "জমা দিন ",
    "title": "{{name}} এর ফলাফল জমা দিন ",
    "subtitle": "আপনার iHealth COVID-19 অ্যাপটি ডাউনলোড অথবা ব্যবহার করার দরকার নেই।",
    "instruction_title": "iHealth এর নির্দেশাবলী দেখুন",
    "instruction_guide": "নির্দেশাবলী পড়ুন",
    "video_guide": "ভিডিও দেখুন",
    "add_photo": "ছবি যোগ করুন ",
    "confirm_result": "ফলাফল নিশ্চিত করুন ",
    "result_warning": "জমা দেবার জন্য ফলাফল চিহ্নিত করুন ",
    "confirm_warning": "জমা দেবার জন্য ফলাফল নিশ্চিত করুন ",
    "administered_at_label": "আপনি কবে টেস্টটি করিয়েছেন?",
    "instruction_subtitle": "আপনার টেস্টের সাথে যেই নির্দেশাবলী এসেছে সেগুলো দেখুন অথবা সেগুলো এখানে আবার দেখুন।"
  },
  "public_test_groups": {
    "title": "কোভিড-১৯ টেস্ট কিট",
    "appointment_recoveries_title": "ফেরত দিচ্ছেন?",
    "appointment_recoveries_button_text": "আমার লিংকটি খুঁজুন",
    "search_test_group_title": "প্রথম বার?",
    "search_test_group_button_text": "এখন রেজিস্টার করুন",
    "title_2": "সহজ রেজিস্ট্রিকরণ এবং রিপোর্টিং",
    "step_one": "অ্যাকাউন্ট রেজিস্ট্রিকরণ",
    "step_two": "ফেরত পাঠাবার জন্য মুখের লালা সংগ্রহ করুন",
    "step_three": "অনলাইনে রেজাল্ট দেখুন",
    "title_3": "আপনার কিটটি চালু করতে রেজিস্টার করুন",
    "population_title": "রেজিস্ট্রিকরণ",
    "population_button": "চালু করুন",
    "faq_subtitle": "আরও জানুন",
    "faq_title": "প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী",
    "faq_1": "আমি আমার টেস্ট কিটটি কিভাবে ফেরত পাঠাবো?",
    "faq_1_footer": "SalivaDirect Funnel Collection সংক্রান্ত নির্দেশিকাগুলি দেখুন",
    "faq_2": "আমি ইতিমধ্যে রেজিস্ট্রিকরণ করেছি কিন্তু আমার অ্যাকাউন্টটি ভুলে গিয়েছি।",
    "faq_3": "আমি আমার কিটটি কিভাবে চালু করব?",
    "faq_2_subtitle": "একজন ফিরতি ব্যবহারকারী হিসেবে উপরে উল্লেখিত '**আমার লিংকটি খুঁজুন**' বাটনটি ব্যবহার করে আপনি আপনার রিপোর্টটি নিশ্চিত করতে পারেন।",
    "faq_3_subtitle": "নিম্নে উল্লেখিত অপশনগুলোর মাধ্যমে অনুগ্রহ করে Primary.Health অ্যাকাউন্ট এর প্রক্রিয়াগুলি সম্পন্ন করুন।",
    "footer_text_1": "এই পণ্যটি FDA দ্বারা অনুমদিত নয়, কিন্তু FDA EUA এর আওতায় জরুরী অবস্থায় ব্যবহারের জন্য অনুমোদন দিয়েছে।",
    "footer_text_2": "এই পণ্যটি শুধুমাত্র SARS-CoV-2 থেকে নিউক্লিক অ্যাসিড সনাক্তকরণে সহায়তা হিসাবে লালা নমুনা সংগ্রহ এবং রক্ষণাবেক্ষণের জন্য অনুমোদিত হয়েছে, অন্য কোনও ভাইরাস বা প্যাথোজেনের জন্য নয়;",
    "footer_text_3": "Federal Food, Drug and Cosmetic Act, 21 U.S.C. § 360bbb-3(b)(1) এর Section 564(b)(1) এর আওতায় এই পণ্যের জরুরী ব্যবহার শুধুমাত্র সেই সময়কালের জন্য অনুমোদিত যখন এমন পরিস্থিতি বিরাজমান যার দরুন মেডিকেল ডিভাইসের জরুরী ব্যবহার যুক্তিসঙ্গত, যদিনা এই অনুমোদনটিতে তার আগেই প্রত্যাহার করা হয়।",
    "description": "আপনার সুবিধার জন্য, আপনি নীচের বোতামগুলি ব্যবহার করে আপনার টেস্ট কিটটি চালু করতে পারেন:",
    "subtitle": "Primary তে প্রথমবার?",
    "subtitle_1": "আপনার কোভিড-১৯ টেস্ট কিটগুলোর ব্যাপারে",
    "faq_1_1": "জৈব স্পেসিমেন ব্যাগটিতে বন্ধ নমুনা টিউবটি ঢোকান",
    "faq_1_2": "জৈবস্পেসিমেন ব্যাগটি SalivaDirect-লেবেলযুক্ত  যে বাক্স এসেছে তাতে রাখুন। SalivaDirect-লেবেলযুক্ত বাক্সটি FedEx UN 3373 Pak-এ রাখুন।",
    "faq_1_3": "FedEx UN 3373 Pak-এর আঠালো লাইনারটি সরান এবং Pak টিকে শক্তভাবে লাগাবার জন্য জোরে চাপুন।",
    "faq_1_4": "অনুগ্রহ করে আপনার নমুনাটি যেদিন সংগ্রহ করবেন সেই দিন এবং শেষ পিকআপের সময়ের আগে জমা দিন। উইকএন্ডে ড্রপ বক্সে আপনার নমুনা সরবরাহ করবেন না।",
    "faq_1_5": "ড্রপ বক্সের অবস্থান দেখতে এবং সময়সূচী জানতে **[fedex.com/labreturns](https://www.fedex.com/labreturns)** এ FedEx ওয়েবসাইট দেখুন।",
    "demo": {
      "title": "COVID-19 at-home test kit additional information & instructions",
      "online_instructions": "Online instructions",
      "download_instructions": "Download instruction sheet",
      "begin": "Begin",
      "instructions": {
        "welcome_title": "Welcome to the at-home COVID-19 testing portal.",
        "welcome_text_1": "Before you start testing, wash you hands or use hand sanitizer.",
        "welcome_text_2": "Make sure your hands are dry before starting.",
        "continue": "Continue",
        "back": "Back",
        "step_one_title": "Step 1: Check your test kit",
        "step_one_text_1": "Locate the kit components:",
        "step_one_text_2": "It is recommended gloves (not provided) also be used during testing.",
        "step_two_title": "Step 2: Place tube in the tube holder",
        "step_two_text_1": "Remove cap from one **TUBE** and place it in the **TUBE HOLDER.**",
        "step_two_text_2": "**NOTE:** Use of gloves is recommended.",
        "step_five_title": "Step 5: Remove swab from the tube",
        "step_five_text_1": "After **ONE MINUTE**, remove the swab from the **TUBE** by rubbing the swab head against the inside wall of the tube to squeeze out as much liquid as possible.",
        "step_five_text_2": "Dispose of swab in the trash.",
        "step_six_title": "Step 6: Open the test strip",
        "step_six_text_1": "Open the **TEST STRIP** pouch carefully at the slit and hold the **TEST STRIP** as indicated.",
        "step_seven_title": "Step 7: Place test strip in the tube",
        "step_seven_text_1": "Place the **TEST STRIP** into the **TUBE** with the arrows pointing down. Leave the strip in the **TUBE** for a **FULL TEN MINUTES**– do not handle or remove.",
        "step_eight_title": "Step 8: Remove test strip from the tube",
        "step_eight_text_1": "At **TEN MINUTES**, remove the **TEST STRIP** from the **TUBE**. Next, place the **TEST STRIP** on the outline in Steps 10-12. Ensure the **TEST STRIP** is on a flat surface in good lighting.",
        "step_eight_text_2": "**Note:** The test is intended to be read at 10 minutes. If the test is read before this or is read more than 5 minutes after the indicated read time, results may be inaccurate (false negative, false positive, or invalid) and the test should be repeated.",
        "step_nine_title": "Step 9: Check your results",
        "step_nine_text_1": "There are three type of results possible.",
        "step_nine_text_2": "Check for a Positive Result",
        "step_nine_text_3": "Check for a Negative Result",
        "step_nine_text_4": "Check for an Invalid Result",
        "step_ten_title": "Step 10: Remove test strip from the tube",
        "step_ten_text_1": "Place the **TEST STRIP** on the test strip outline below and compare with test result examples shown.",
        "step_three_title": "Step 3: Swab the nostrils",
        "step_three_text_1": "Remove the **SWAB** from its wrapper, being careful not to touch the **SWAB** head.",
        "step_three_text_2": "Gently insert the **SWAB** ½ to ¾ of an inch into the nostril, depending on the size of the person’s nose. Firmly rub the **SWAB** in a circular motion around the inside wall of EACH NOSTRIL at least 4 times.",
        "step_three_text_3": "Be sure to rub BOTH nostrils with the SAME SWAB.",
        "step_three_text_5": "**NOTE:** Failure to swab properly may cause false negative results.",
        "step_four_title": "Step 4: Place swab in the tube",
        "step_four_text_1": "Immediately place the **SWAB** into the liquid inside the **TUBE**, and ensure it is touching the bottom. Stir 3-4 times.",
        "step_four_text_2": "Leave the swab in the solution for **ONE MINUTE**.",
        "step_four_text_3": "**NOTE**: If the swab is in the solution for more than 10-minutes it should not be used.",
        "step_three_text_4": "**NOTE:** If you are swabbing others, please wear a face mask. With children, you may not need to insert the swab as far into the nostril. For very young children, you may need another person to steady the child’s head while swabbing."
      },
      "choose_language": "Choose your language"
    }
  },
  "self_resulting": {
    "report_result": "ফলাফল রিপোর্ট করুন ",
    "report_result_subtitle": "আপনার সংস্থা যদি নিজস্ব টেস্ট করার ব্যবস্থা করে দেয়, এবং আপনি যদি আপনার ফলাফল রিপোর্ট করতে প্রস্তুত থাকেন, তবে অনুগ্রহ করে নিচের বাটনটি ক্লিক করুন। ",
    "need_help": "আপনার কি সাহায্য লাগবে?",
    "assistance": "আপনার কোন সহযোগিতার জন্য অথবা আপনার যোগাযোগের তথ্য পরিবর্তন করার জন্য অনুগ্রহ করে সাপোর্ট সেন্টার এর সাথে যোগাযোগ করুন। ",
    "contact_support": "সহযোগিতার জন্য যোগাযোগ করুন",
    "save_link": "ফলাফল পরবর্তীতে রিপোর্ট করার জন্য এই লিঙ্কটি সংরক্ষণ করুন",
    "send_via_email": "ইমেইলের মাধ্যমে লিঙ্ক পাঠান",
    "send_via_text": "এসএমএস এর মাধ্যমে লিঙ্ক পাঠান",
    "copy_link": "লিঙ্কটি কপি করুন",
    "resend_email": "ইমেইল ভেরিফিকেশনটি আবার পাঠান ",
    "phone_verified": "ফোনের ভেরিফিকেশন হয়েছে",
    "add_vaccination_status": "আপনার কোভিড-১৯ ভাক্সিন সঙ্ক্রান্ত তথ্য যোগ/হালনাগাদ করুন ",
    "terms_of_service": "সেবা পাবার শর্ত",
    "verify_contact_information": "আপনি আপনার যোগাযোগের তথ্যগুলি ভেরিফাই করুন যাতে করে আপনি আপনার ফলাফল ও অন্যান্য তথ্যাদি পেতে পারেন। আপনার যদি নিজের যোগাযোগের তথ্য পরিবর্তন করতে হয়, তবে অনুগ্র করে আমাদের সাপোর্ট সেন্টারের সাথে যোগাযোগ করুন। ",
    "resend_text": "এসএমএস ভেরিফিকেশনটি আবার পাঠান ",
    "loading": "লোড হচ্ছে ",
    "add_to_account": "অ্যাকাউন্টে যোগ করুন ",
    "hi": "স্বাগতম",
    "email_verified": "ইমেইল ভেরিফিকেশন সম্পন্ন হয়েছে",
    "go_to_my_account": "আমার অ্যাকাউন্টে যান",
    "activate_kit": "একটি টেস্ট কিট চালু করুন",
    "report_custom_result": "একটি ফলাফলের প্রতিবেদন করুন: {{test}}",
    "activate_custom_test": "একটি পরীক্ষা চালু করুন: {{test}}",
    "update_vaccination_status": "টিকাকরণ স্থিতি আপডেট করুন",
    "order_a_test_kit": "একটি পরীক্ষার কিট অর্ডার করুন"
  },
  "enter_information": {
    "contact_info": "আপনার যোগাযেগের তথ্য লিখুন",
    "label": "ফোন অথবা ইমেইল",
    "invalid": "এটি সঠিক ইমেইল বা ফোন নম্বর নয়। ",
    "send": "আমরা আপনার ফোনে অথবা ইমেইলে একটি কোড পাঠাবো ",
    "legal": "আপনার ফোন নম্বর অথবা ইমেইল দেয়ার মাধ্যমে আপনি Primary Health এর  **[সেবা পাবার শর্তের](https://primary.health/terms-of-service/)** এবং **[গোপনীয়তা নীতির](https://primary.health/privacy-policy/)** সাথে সম্মতি দিচ্ছেন।",
    "subtitle": "আমরা আপনাকে একটি মেসেজ বা ই মেল পাঠাব যাতে আপনি আপনার রেকর্ড খুঁজে পেতে বা টেস্ট এর ফলাফল বের করার লিঙ্ক খুঁজে পেতে পারেন।",
    "find_link": "আপনার নিবন্ধন সম্পন্ন হয়েছে? আপনার লিংক এখানে পাবেন",
    "not_registered": "অনিবন্ধিত? আপনার সাইট সার্চ করুন",
    "search_by_keyword": "নাম, কীওয়ার্ড, শহর, জিপ বা সংস্থার কোড দিয়ে সার্চ করুন",
    "search": "সার্চ করুন",
    "register_here": "এখানে নিবন্ধিত করুন"
  },
  "contact_support": {
    "invalid": "সঠিক তথ্য নয় ",
    "invalid_explanation": "আপনি সম্প্রতি Primary.Health কে একটি সাইন-অন লিঙ্কের জন্য অনুরোধ করেছিলেন। কিন্তু, ",
    "never_registered": "এর আগে কি কখনো নিবন্ধন করেননি? দয়া করে রেজিস্ট্রেশন লিঙ্কের জন্য আপনার পরীক্ষা প্রদানকারীর সাথে যোগাযোগ করুন, অথবা নীচে আপনার সাইট খুঁজুন।",
    "get_help": "আপনার রেকর্ডের সাথে আপনার যোগাযোগের তথ্যর মিল করার জন্য আপনি সাহায্য পেতে পারেন ",
    "get_help_calling": "অথবা ফোন করার মাধ্যমে ",
    "invalid_explanation_bold": "আপনার দেয়া তথ্যটি ভুল। ",
    "get_help_label": "সাহায্য পান",
    "mobile": {
      "invalid_explanation": "আপনার অ্যাকাউন্টে যোগ করা যেতে পারে এমন কোনো ব্যবহারকারী পাওয়া যায়নি।",
      "get_help": "আপনার কোন অতিরিক্ত প্রশ্ন থাকলে, যোগাযোগ করুন",
      "reason": "সমস্ত প্রাথমিক স্বাস্থ্য ব্যবহারকারী আমাদের নতুন অ্যাকাউন্ট বৈশিষ্ট্যের জন্য যোগ্য নয়। একবার আপনি যোগ্য হয়ে গেলে, আপনি প্রাথমিক স্বাস্থ্য বা আপনার গ্রুপ অ্যাডমিনিস্ট্রেটরের কাছ থেকে একটি আমন্ত্রণ পাবেন।"
    },
    "zen_name": "যোগাযোগের নাম",
    "ticket_type": "কি ব্যাপারে",
    "appointment_access_code": "কনফারমেশন কোড (যদি জানা থাকে)",
    "zen_desc": "বার্তা",
    "contact_us": "আমাদের সাথে যোগাযোগ করুন",
    "need_assistance": "সাহায্যের প্রয়োজন হলে, বা যোগাযোগ সম্বন্ধীয় তথ্য বদলাতে হলে, আমাদের সাথে যোগাযোগ করুন।"
  },
  "show_appointments": {
    "welcome": "আপনার প্রোফাইলটি খুঁজুন",
    "welcome_subtitle_1": "নীচের ফলাফলগুলির থেকে ",
    "added_to_account": "অ্যাকাউন্টে যোগ করা হয়েছে",
    "error": "এই অংশগ্রহণকারীর ইতিমধ্যেই একটি অ্যাকাউন্ট থাকতে পারে৷",
    "welcome_subtitle_2": "নীচে আপনার নাম দেখতে পাচ্ছেন না?",
    "welcome_not_logged_in": "সাইটের লিংক খোঁজা হচ্ছে",
    "welcome_logged_in": "আপনার গ্ৰুপ নির্বাচন করুন",
    "welcome_subtitle_1_logged_in": "আরও একজন সদস্য যোগ করার পর, ব্যবহারকারী এবং গ্ৰুপ নির্বাচন করুন।  সব সদস্যদের একটি অ্যাকাউন্টে বরাদ্দ করা হবে।",
    "welcome_subtitle_2_logged_in": "আপনি যদি আপনাার সদস্যকে দেখতে না পান, তাহলে আপনি",
    "welcome_subtitle_1_not_logged_in": "কে তাদের সাইটটি সনাক্ত করতে বা একজন নতুন সদস্য যোগ করতে চান তাকে নির্বাচিত করুন৷  সদস্য পাননি?",
    "welcome_subtitle_3_logged_in": "অন্য কন্টাক্ট মেথড প্রয়োগ করে দেখতে পারেন",
    "welcome_subtitle_4_logged_in": "অথবা যোগাযোগ করতে পারেন",
    "welcome_subtitle_2_not_logged_in": "আপডেট সার্চের মাধ্যমে।",
    "welcome_subtitle_3": "আপনার সার্চ আপডেট করুন"
  },
  "enter_code": {
    "code": "কোডটি কী?",
    "enter_code": "পাঠানো কোডটি প্রবেশ করুন ",
    "incorrect_code": "আপনি ভুল কোড প্রবেশ করেছেন।",
    "verify": "অ্যাকাউন্ট ভেরিফিকেশন করুন ",
    "verified": "ভেরিফাই করা হয়েছে ",
    "verify_account_information": "আপনার অ্যাকাউন্ট যাচাই করে নিন"
  },
  "general_self_checkout": {
    "choose_test": "আপনি কোন টেস্টটি করিয়েছেন?",
    "photo_required": "রেজাল্টের ছবি আবশ্যক",
    "find_your_test": "আপনার টেস্টটি খুঁজুন"
  },
  "login": {
    "create_account": "একটি অ্যাকাউন্ট বানান ",
    "create_account_help": "একটি অ্যাকাউন্ট তৈরি করা পরীক্ষা বা ভ্যাকসিনেশনের জন্য নিবন্ধন করার মতো নয়। একবার আপনি নিবন্ধন করেছেন।",
    "create_account_help_schedule": "অ্যাপয়েন্টমেন্ট এর সময় নির্ধারণ করা ",
    "create_account_help_record": "বাসার টেস্টগুলি রেকর্ড করা",
    "create_account_help_match": "ভাক্সিনের ও টেস্টের রেকর্ডগুলি তদারকি করা।",
    "continue": "গেস্ট হিসেবে চালিয়ে যান ",
    "already": "আপনার ইতিমধ্যে একটি অ্যাকাউন্ট আছে? ক্লিক করুন ",
    "login": "লগইন করার জন্য। ",
    "or_sign_in": "অথবা সাইন ইন করার জন্যঃ ",
    "no_account": "আপনার অ্যাকাউন্ট নেই? ক্লিক করুন ",
    "signup": "সাইন আপ করার জন্য",
    "here": "এখানে",
    "email_address": "ইমেইলের ঠিকানাঃ ",
    "password": "পাসওয়ার্ডঃ",
    "complete_registration": "রেজিস্ট্রেশন সম্পন্ন করুন ",
    "last_covid_test": "সর্বশেষ কোভিড-১৯ টেস্টের ফলাফল ",
    "no_record": "কোন রেকর্ড নেই ",
    "viewing_information": "{{first_name}} এর তথ্য দেখানো হচ্ছে",
    "download": "ডাউনলোড করুন ",
    "not_registered": "আপাত দেখা যাচ্ছে যে আপনি কোন গ্রুপের সাথে রেজিস্ট্রিভুক্ত নন ",
    "please_follow_link": "Primary.Health এর সাথে সময় নির্ধারণ করতে ও আপনার তথ্য অ্যাক্সেস করতে অনুগ্রহ করে আপনার ইমেইল এ পাঠানো আমন্ত্রণ লিঙ্কটি ব্যবহার করুন। ",
    "log_results": "আমার টেস্ট রেজাল্টগুলি নথিভুক্ত করুন ",
    "book_appointment": "অ্যাপয়েন্টমেন্ট বুক করুন ",
    "no_new_appointments": "বর্তমানে নতুন অ্যাপয়েন্টমেন্ট নেয়া হচ্ছে না ",
    "upload_vaccinations": "ভ্যাক্সিনেশনগুলি আপলোড করুন ",
    "vaccination": "ভ্যাক্সিনেশন ",
    "new_appointment": "নতুন অ্যাপয়েন্টমেন্ট",
    "log_otc_results": "একটি OTC টেস্টের ফলাফল যোগ করুন ",
    "no_household_members": "আপনি এখনো কোন পরিবারের সদস্যদের যোগ করেননি।",
    "no_upcoming": "কোন পরবর্তী অ্যাপয়েন্টমেন্ট নেই ",
    "update_vaccination": "ভাক্সিনের তথ্য হালনাগাদ করুন ",
    "upload_vaccination": "ভাক্সিনের তথ্য আপলোড করুন ",
    "title": "Primary.Health এ স্বাগতম ",
    "sub_title": "Before registering please create an account.",
    "p1": "একটি অ্যাকাউন্ট বানানোর মাধ্যমে আপনি পারবেনঃ ",
    "p2": "ভবিষ্যতের অ্যাপয়েন্টমেন্ট এর সময় নির্ধারণ করা",
    "p3": "বাসার কোভিড-১৯ টেস্টগুলি রেকর্ড করা",
    "p4": "আপনার ওপর নির্ভরশীল ব্যক্তিদের ভাক্সিনের ও টেস্টের রেকর্ডগুলি তদারকি করা",
    "p5": "my.primary.health থেকে সহজভাবে লগইন করবার পদ্ধতি ",
    "no_vaccination_record": "এখনও কোনও টিকা যোগ করা হয়নি",
    "vaccination_title_card": "কভিড-১৯ টিকাকরণের অবস্থা",
    "account_and_settings": "অ্যাকাউন্ট ও সেটিংস",
    "delete_account": "অ্যাকাউন্ট মুছে ফেলা",
    "language": "ভাষা",
    "language_current": "বর্তমান ভাষা: {{language}}",
    "log_out": "লগ আউট",
    "delete_account_title": "আপনি কি নিশ্চিত যে আপনি আপনার অ্যাকাউন্ট মুছে ফেলতে চান?",
    "new_encounter": "{{first_name}}-এর নতুন এনকাউন্টার",
    "new_encounter_subtitle": "কোন গ্রুপের জন্য এই নতুন এনকাউন্টার?",
    "no_programs": "দেখে মনে হচ্ছে আপনি কোনও প্রোগ্রামে ভর্তি হননি",
    "edit_members": "সদস্যদের সম্পাদনা করুন",
    "edit_members_subtitle": "আপনি কোন ড্যাশবোর্ডে যেতে চান তা নির্বাচন করুন বা আপনার অ্যাকাউন্টে অন্য কোনও সদস্য যুক্ত করুন",
    "add_members": "সদস্য যুক্ত করুন",
    "delete_member": "{{full_name}}-এর ব্যবহারকারীর অ্যাকাউন্ট মুছবেন?",
    "delete_member_subtitle": "ব্যবহারকারীকে অপসারণ করা হলে অ্যাকাউন্টের সাথে সম্পর্কিত সমস্ত তথ্য মুছে যাবে।",
    "select_member": "সদস্য নির্বাচন",
    "edit_appointment": "অ্যাপয়েন্টমেন্ট সম্পাদনা করুন",
    "route": {
      "me": "ড্যাশবোর্ড",
      "history": "ইতিহাস",
      "programs": "একটি পরীক্ষা যোগ করুন",
      "contact_us": "সহায়তা",
      "choose_member": "সদস্য",
      "settings": "সেটিংস",
      "help": "সহায়তা"
    },
    "user_dashboard": "{{first_name}}-এর ড্যাশবোর্ড",
    "view_full_results": "ফলাফল পোর্টালে দেখুন",
    "required": "আপনি যদি প্রাইমারি অ্যাপ ব্যবহার করেন তাহলে প্রয়োজন।",
    "no_email": "আমার কোনো ইমেল এড্রেস নেই।"
  },
  "vaccination_status": {
    "not_vaccinated": "কোন ভাক্সিন দেয়া হয়নি ",
    "fully_vaccinated": "সম্পূর্ণ ভাক্সিন দেয়া হয়েছে ",
    "partially_vaccinated": "আংশিক ভাক্সিন দেয়া হয়েছে ",
    "vaccination_records": "টিকা দেওয়ার রেকর্ড",
    "title": "আপনার কোভিড-১৯ টিকা গ্রহণের অবস্থা কি?",
    "definition_title": "টিকা গ্রহণের অবস্থা বর্ণনা",
    "definition_cdc": "সিএসডি টিকা  গ্রহণের অবস্থা বর্ণনা",
    "definition_osha": "ওএসএইচএ টিকা গ্রহণের অবস্থা বর্ণনা",
    "definition": {
      "fully_vaccinated": "ফাইজার-বায়োটেক( Pfizer-BioNTech) বা মর্ডানা (Moderna) এর ২ ডোজ সিরিজের চূড়ান্ত ডোজ বা জনসন অ্যান্ড জনসন'স জ্যানসেনের(Johnson & Johnson's Janssen) ভ্যাকসিনের ১ ডোজের ২ সপ্তাহ পরে।",
      "partially_vaccinated": "প্রাইমারি সিরিজে ২টির মধ্যে মাত্র ১টি ডোজ বা ১টি ডোজ সিরিজে চূড়ান্ত ডোজ পাওয়ার ২ সপ্তাহেরও কম সময় বা জনসন অ্যান্ড জনসন'স জ্যানসেনের ১ ডোজ  গ্রহণ করা হয়েছে।",
      "not_vaccinated": "কোনো কোভিড-১৯ টিকা দেওয়া হয়নি।",
      "fully_vaccinated_with_one_booster": "সম্পূর্ণ সিরিজের পরে ফাইজার-বায়োটেক( Pfizer-BioNTech) বা মর্ডানা (Moderna) ভ্যাকসিনের একটি বুস্টার ডোজ বা জনসন অ্যান্ড জনসন'স জ্যানসেনের (Johnson & Johnson's Janssen) ভ্যাকসিনের ১ ডোজ  গ্রহণ করা হয়েছে।",
      "fully_vaccinated_with_two_boosters": "জনসন অ্যান্ড জনসনের জ্যানসেন ভ্যাকসিন এবং বুস্টার ডোজ এর সম্পূর্ণ সিরিজ বা ডোজ পরে Pfizer-BioNTech বা Moderna ভ্যাকসিনের দ্বিতীয় বুস্টার ডোজ পেয়েছেন।"
    },
    "label": {
      "fully_vaccinated": "সম্পূর্ণ টিকা নেয়া হয়েছে",
      "partially_vaccinated": "আংশিক টিকা নেয়া হয়েছে",
      "not_vaccinated": "টিকা নেয়া হয়নি",
      "fully_vaccinated_with_one_booster": "সম্পূর্ণ টিকা নেয়া হয়েছে + বুস্টার নেয়া হয়েছে",
      "fully_vaccinated_with_two_boosters": "সম্পূর্ণ টিকা নেয়া হয়েছে + ২টা বুস্টার নেয়া হয়েছে",
      "prefer_not_to_answer": "উত্তর দিতে স্বাচ্ছন্দ্য বোধ করছিনা"
    },
    "progress_bar_title": "কোভিড-১৯ টিকা গ্রহণের ইতিহাস",
    "upload_record_card": "আপনার কোভিড-১৯ টিকার রেকর্ড কার্ড আপলোড করুন",
    "show_example": "উদাহরণ দিন",
    "hide_example": "উদাহরণ গোপন করুন",
    "take_photo": "ছবি তুলতে ক্লিক করুন",
    "or": "অথবা",
    "upload_image_or_pdf_instead": "তার পরিবর্তে ছবি/পিডিএফ আপলোড করুন",
    "select_doses_received": "আপনার পাওয়া সমস্ত কোভিড-১৯ টিকার ডোজ নির্বাচন করুন।",
    "first_dose": "১ম ডোজ",
    "second_dose": "২য় ডোজ",
    "first_booster_dose": "১ম বুস্টার ডোজ",
    "second_booster_dose": "২য় বুস্টার ডোজ",
    "additional_dose": "অতিরিক্ত ডোজ",
    "first_dose_manufacturer": "আপনার কোভিড-১৯ টিকার প্রথম ডোজের প্রস্তুতকারক কে ছিলো?",
    "first_dose_date": "আপনার প্রথম ডোজের তারিখ কত ছিলো?",
    "second_dose_manufacturer": "আপনার কোভিড-১৯ টিকার ২য় ডোজের প্রস্তুতকারক কে ছিলো?",
    "second_dose_date": "আপনার ২য় ডোজের তারিখ কত ছিলো?",
    "first_booster_dose_manufacturer": "আপনার কোভিড-১৯ টিকার প্রথম বুস্টার ডোজের প্রস্তুতকারক কে ছিলো?",
    "first_booster_dose_date": "আপনার প্রথম বুস্টার ডোজের তারিখ কত ছিলো?",
    "second_booster_dose_manufacturer": "আপনার কোভিড-১৯ টিকার ২য় বুস্টার ডোজের প্রস্তুতকারক কে ছিলো?",
    "second_booster_dose_date": "আপনার ২য় বুস্টার ডোজের তারিখ কত ছিলো?",
    "additional_dose_manufacturer": "আপনার কোভিড-১৯ টিকার অতিরিক্ত ডোজের প্রস্তুতকারক কে ছিলো?",
    "additional_dose_date": "আপনার অতিরিক্ত ডোজের তারিখ কত ছিলো?",
    "completed_one": "সম্পূর্ণ করুন",
    "completed_two": "টিকার তথ্য আপডেট করার জন্য আপনাকে ধন্যবাদ!",
    "progress_bar_complete": "সম্পূর্ণ করুন",
    "upload_image": "ছবি আপলোড  করুন",
    "retake_photo": "পুনরায় ছবি তুলুন",
    "other": "অন্য",
    "remove_first_dose": "প্রথম ডোজের ইতিহাস মুছে ফেলুন",
    "remove_second_dose": "২য় ডোজের ইতিহাস মুছে ফেলুন",
    "remove_first_booster_dose": "প্রথম বুস্টার ডোজের ইতিহাস মুছে ফেলুন",
    "remove_second_booster_dose": "২য় ডোজের ইতিহাস মুছে ফেলুন",
    "remove_additional_dose": "অতিরিক্ত ডোজের ইতিহাস মুছে ফেলুন",
    "exemption": "আপনি একটি অব্যাহতি/ছাড় আছে?",
    "exempt": "আমি অব্যাহতি/ছাড় প্রাপ্ত",
    "not_exempt": "আমি অব্যাহতি/ছাড় প্রাপ্ত নই",
    "enter_exemption": "ছাড় লিখুন",
    "upload_exemption_documentation": "আপনার ছাড়ের জন্য ডকুমেন্টেশন আপলোড করুন",
    "remove_dose": "ডোজ মুছে ফেলুন",
    "continue": "চালিয়ে যান",
    "enter_credentials": "আপনার প্রমাণপত্র (ক্রিডেনশিয়াল) প্রবেশ করান",
    "incorrect_credentials": "ভুল প্রমাণপত্র (ভুল ক্রিডেনশিয়াল) পুনরায় প্রবেশ করান",
    "add_photo": "ছবি যুক্ত করুন"
  },
  "mailers": {
    "appointment_mailer": {
      "payment_pending": "হ্যালো {{name}}, আমরা লক্ষ্য করেছি যে আপনি {{org_name}}-এর সাথে আপনার {{group_name}} অ্যাপয়েন্টমেন্টের সময় নির্ধারণ করা শেষ করেননি৷ আপনার অ্যাপয়েন্টমেন্ট রাখতে, আপনাকে অর্থপ্রদানের পদক্ষেপটি সম্পূর্ণ করতে হবে। প্রক্রিয়াটি সম্পূর্ণ করতে অনুগ্রহ করে এই লিঙ্কে ক্লিক করুন {{complete_url}}। আপনি যদি আপনার অ্যাপয়েন্টমেন্ট বাতিল করতে চান, অনুগ্রহ করে এই লিঙ্কে ক্লিক করুন {{cancel_url}}। ধন্যবাদ"
    }
  },
  "otc": {
    "record_results_for_abbott": "BinaxNOW পরীক্ষার জন্য আপনার ফলাফল পরীক্ষা করুন এবং রেকর্ড করুন",
    "record_results": "পরীক্ষা করুন এবং আপনার ফলাফল রেকর্ড করুন",
    "activate_a_kit": "একটি কিট সক্রিয় করুন",
    "activate_a_kit_for_test": "{{test}} এর জন্য একটি কিট চালু করুন",
    "todays_test_process": "আজকের পরীক্ষা প্রক্রিয়া:",
    "date_of_birth_question": "{{first_name}} -এর জন্ম তারিখ কী?",
    "confirm_dob_to_continue": "চালিয়ে যেতে অনুগ্রহ করে অংশগ্রহণকারীর জন্ম তারিখ নিশ্চিত করুন:",
    "incorrect_dob": "জন্ম তারিখ ভুল",
    "file_too_large": "দয়া করে নিশ্চিত করুন যে আপলোড করা ফাইলের আকার {{size}}-এর চেয়ে ছোট",
    "enter_valid_date_in_last_x_days": "গত {{n}} দিনের মধ্যে একটি বৈধ তারিখ লিখুন",
    "barcode_format_not_valid": "বারকোড বিন্যাস বৈধ নয়৷",
    "complete_button": "সম্পূর্ণ",
    "next_button": "পরবর্তী",
    "back_button": "পেছনে",
    "report_a_test": "একটি পরীক্ষার রিপোর্ট করুন:",
    "x_%_completed": "{{n}}% সম্পূর্ণ",
    "answer_survey": "জরিপ প্রশ্নের উত্তর দিন",
    "steps": {
      "answer_survey": "জরিপ উত্তর",
      "review_instructions": "নির্দেশাবলী পর্যালোচনা করুন",
      "scan_code": "কোড স্ক্যান করুন",
      "enter_time": "সময় প্রবেশ করান",
      "enter_result": "ফলাফল প্রবেশ করান",
      "take_photo": "ছবি তোল",
      "confirm_result": "ফলাফল নিশ্চিত করুন",
      "selest_test_kit": "পরীক্ষার ধরন বেছে নিন",
      "enter_date": "তারিখ প্রবেশ করান",
      "enter_date_and_time": "তারিখ এবং সময় প্রবেশ করান"
    },
    "review_instructions": "পরীক্ষার নির্দেশাবলী পর্যালোচনা করুন",
    "follow_instructions_or_below": "আপনার পরীক্ষার সাথে আসা নির্দেশাবলী অনুসরণ করুন অথবা নীচের নির্দেশাবলী পর্যালোচনা করুন।",
    "watch_video": "ভিডিও দেখুন",
    "view_instructions": "নির্দেশাবলী দেখুন",
    "follow_instructions": "আপনার পরীক্ষার সাথে যে নির্দেশাবলী এসেছে তা অনুসরণ করুন।",
    "scan_code": "পরীক্ষার QR কোড স্ক্যান করুন",
    "qr_code_description": "QR কোডটি আপনার পরীক্ষার জন্য অনন্য এবং এটি আপনার পরীক্ষার উপরের ডানদিকের কোণায় পাওয়া যাবে",
    "show_example": "উদাহরণ দেখাও",
    "hide_example": "লুকান উদাহরণ",
    "barcode_scanned": "বারকোড সফলভাবে স্ক্যান করা হয়েছে৷",
    "enter_barcode": "বারকোড লিখুনবারকোড প্রবেশ করান",
    "scan_qr_code": "QR কোড স্ক্যান করুন",
    "which_test_did_you_take": "আপনি কোন পরীক্ষা গ্রহণ করেছেন?",
    "when_did_you_take_test": "আপনি কখন এই পরীক্ষা দিয়েছেন?",
    "what_day_did_you_take_test": "আপনি কোন দিন এই পরীক্ষা দিয়েছেন?",
    "what_time_did_you_take_test": "আপনি কোন সময়ে এই পরীক্ষা দিয়েছেন?",
    "time": {
      "today": "আজ",
      "yesterday": "গতকাল",
      "two_days_ago": "দুই দিন আগে"
    },
    "enter_current_time": "বর্তমান সময় প্রবেশ করান",
    "enter_result": "পরীক্ষার ফলাফল প্রবেশ করান",
    "choose_result_option": "আপনার টেস্টিং কার্ডের ফলাফল বর্ণনা করে এমন বিকল্পটি বেছে নিন:",
    "clarify_results": "আপনার ফলাফল স্পষ্ট করুন",
    "take_result_photo": "ফলাফলের একটি ছবি তুলুন",
    "take_result_photo_description": "আপনার ফলাফল রেকর্ড করতে সম্পূর্ণ ফলাফল কার্ডের একটি ছবি তুলুন।",
    "my_result": "আমার ফলাফল",
    "switch_camera": "ক্যামেরা সুইচ করুন",
    "confirm_result": "ফলাফল নিশ্চিত করুন",
    "name": "নাম:",
    "date": "তারিখ:",
    "result": "ফলাফল:",
    "results": "ফলাফল",
    "test_submitted": "ধন্যবাদ, {{first_name}}! আপনার {{test}} সফলভাবে জমা দেওয়া হয়েছে।",
    "dob": "জন্ম তারিখ:",
    "administered": "পরিচালিত:",
    "or": "বা",
    "upload": "আপলোড করুন",
    "change_uploaded_file": "আপলোড করা ফাইল পরিবর্তন করুন",
    "take_photo": "একটি ছবি তুলুন",
    "confirm_information": "তথ্য নিশ্চিত করুন",
    "barcode": "বারকোড:",
    "scan_test_barcode": "পরীক্ষার বারকোড স্ক্যান করুন",
    "barcode_description": "বারকোড আপনার পরীক্ষার জন্য অনন্য এবং আপনার পরীক্ষায় পাওয়া যাবে",
    "enter_date_in_last_30_days": "গত 30 দিনের মধ্যে একটি তারিখ এবং পরীক্ষা নেওয়ার আনুমানিক সময় লিখুন৷",
    "add_image": "ছবি যোগ করুন",
    "change_image": "ছবি পরিবর্তন",
    "skip_barcode_reader": "কোডটি স্ক্যান করতে পারছেন না? যাইহোক একটি পরীক্ষার ফলাফল রিপোর্ট করতে পরবর্তী ক্লিক করুন",
    "enter_date_and_time": "পরীক্ষার তারিখ এবং সময় প্রবেশ করান",
    "enter_date": "পরীক্ষার তারিখ প্রবেশ করান",
    "did_you_take_test_today": "আপনি কি আজ পরীক্ষা দিয়েছেন?",
    "record_results_for_generic": "{{name}} পরীক্ষার জন্য আপনার ফলাফলটি টেস্ট করে রেকর্ড করে রাখুন",
    "choose_result_option_custom": "এমন বিকল্প পছন্দ করুন যে আপনার {{test_name}} এর ফলফলকে ব্যক্ত করে:"
  },
  "yes": "হ্যা",
  "no": "না",
  "event_token": {
    "title": "আপনার পরীক্ষার কিট বিতরণ করার জন্য অনুগ্রহ করে ভেন্ডিং মেশিনে নীচের কোডটি প্রবেশ করান৷",
    "loading_text": "লোড হচ্ছে, অনুগ্রহ করে এক মিনিটের মধ্যে আবার চেক করুন"
  },
  "appointment_recovery": {
    "complete_title": "আপনি সম্পূর্ন প্রস্তুত!",
    "subtitle_1": "আপনি যদিআইফোন ব্যবহার করে থাকেন তবে আপনার ড্যাশবোর্ডে ফিরে যেতে দয়া করে এই স্ক্রিনের উপরের বাম দিকের কোণে **Done** আলতো চাপুন।",
    "subtitle_2": "আপনি যদি অ্যান্ড্রয়েড ব্যবহার করে থাকেন তবে এই স্ক্রিনের উপরের বাম দিকের কোণে **X** আলতো চাপুন।",
    "subtitle_0": "অবিরত রাখতে অনুগ্রহ করে ব্রাউজার থেকে প্রস্থান করুন।"
  },
  "primary": {
    "support_email": "support@primary.health"
  },
  "consented_relationship": "সম্মতি জ্ঞাপনকৃত সম্পর্ক",
  "finish_registration": {
    "title": "আপনার নিবন্ধন সম্পূর্ণ করুন",
    "subtitle": "আপনার অ্যাপয়েন্টমেন্টের আগে নিম্নলিখিত তথ্য সম্পূর্ণ করুন:",
    "button": "নিবন্ধনকরণ সম্পন্ন করুন"
  },
  "arab_ethnicity": {
    "arab": "আরব",
    "non_arab": "অ-আরব",
    "prefer_not_to_answer": "উত্তর দিতে স্বাচ্ছন্দ্য বোধ করছিনা",
    "question": "আরব নৃগোষ্ঠী",
    "subtitle": "আমরা যে নিম্নলিখিত তথ্য সংগ্রহ করি তার জন্য প্রবিধান (রেগুলেশন) প্রয়োজন",
    "help": "জাতিসত্তা বলতে বোঝায় সাধারণ বৈশিষ্ট্য যেমন ভাষা, সাংস্কৃতিক রীতিনীতি, ধর্ম এবং অন্যান্য বৈশিষ্ট্য যা মানুষের গোষ্ঠীকে আলাদা করতে ব্যবহৃত হয়। জাতিগত পরিচয়ের সাথে এর সংযোগ থাকতেও পারে বা নাও পারে।"
  },
  "custom_comms_quick_add": {
    "mobile_app_links": {
      "email_text": "আপনার ডিভাইসের ওপর নির্ভর করে, প্রাইমারি হেলথ পাস ডাউনলোড করতে নীচের লিঙ্কে ক্লিক করুন।"
    }
  },
  "stepper": {
    "next": "সামনে যান",
    "back": "পেছনে যান",
    "complete": "সম্পূর্ণ করুন"
  },
  "registration_direcory": {
    "keyword_search_label": "কিওয়ার্ড, শহরের নাম, জিপ কোড, সংস্থার নাম",
    "keyword_search_label_mobile": "শহরের নাম, জিপ কোড, সংস্থার নাম",
    "zero_results": {
      "title": "প্রদত্ত সার্চ টার্মে আমরা কোনো প্রদানকারী পাচ্ছি না।",
      "sub_title": "আপনার প্রদানকারীর খোঁজ শুরু করুন:",
      "p1": "জিপ কোড",
      "p2": "শহরের নাম",
      "p3": "দেশের নাম",
      "p4": "প্রদানকারী বা সংস্থার নাম"
    }
  },
  "registration_flyer": {
    "open_camera": "আপনার ডিভাইসের ক্যামেরা অ্যাপটি খুলুন",
    "point_to_qr_code": "কিউ আর কোডের দিকে নির্দেশ করে লিঙ্কে চাপ দিন",
    "complete_registration": "নিবন্ধন সম্পূর্ণ করুন",
    "need_help": "সাহায্য প্রয়োজন? আমাদের সাথে এই ঠিকানায় যোগাযোগ করুন"
  },
  "vaccine_info_sheets": {
    "vaccine_info_attestation": "ভ্যাকসিন সংক্রান্ত তথ্যের প্রমাণ",
    "select_checkbox": "নিম্নলিখিতগুলি ভালো করে দেখুন এবং এগোনোর আগে নীচের সঠিক চেকবক্সটি নির্বাচন করুন।",
    "opportunity_to_read": "আমাকে প্রদত্ত সেইসকল ভ্যাকসিন ইনফরমেশান স্টেটমেন্ট(গুলি) (“VIS”) অথবা এমারজেন্সি ইউস অথোরাইজেশান (“EUA”) ফ্যাক্ট শিট পড়ার সুযোগ করে দেওয়া হয়েছে যার পরিচালনা প্রয়োজনীয়:",
    "vaccine_info_sheet": "ভ্যাকসিন তথ্যের শিট",
    "vaccine_fact_sheet": "ভ্যাকসিন ফ্যাক্ট শিট ",
    "vaccine_info_statement": "ভ্যাকসিন তথ্যের ব্যাখ্যা",
    "vaccine_info_statements_title": "ভ্যাকসিন তথ্যের শিট"
  },
  "exemption": {
    "dtap_tdap": "DTaP/TDap",
    "mmr": "MMR",
    "ipv_opv": "পোলিও",
    "hib": "HIB",
    "hep_b": "HEPB",
    "var": "ভ্যারিসেলা",
    "hep_a": "HEPA",
    "pcv": "PCV",
    "mcv": "MCV"
  },
  "test_strip": {
    "A": "this kit includes tests for chlamydia and gonorrhea.",
    "B": "this kit includes tests for chlamydia and gonorrhea.",
    "C": "this kit includes tests for syphilis.",
    "D": "this kit includes tests for HIV, syphilis, chlamydia and gonorrhea.",
    "E": "this kit includes tests for HIV and syphilis.",
    "box_type": "Box {{type}}",
    "administered_text": "We will contact you when your kit reaches the lab and when your results are ready.",
    "activate_kit": "Activate my test kit",
    "register_another_test": "Register another test",
    "credentials": {
      "title": "Let's get started",
      "label": "Contact",
      "p1": "We'll start with some info about you.",
      "location_step": {
        "p1": "Who provided your test kit?",
        "load": "Load more"
      }
    },
    "checklist": {
      "not_urinated": "You have not urinated in the last hour.",
      "bathroom": "You have access to a bathroom for urine collection.",
      "anal_swab": "You have access to a private place to perform an anal swab.",
      "blood_extraction": "You have access to a clean environment for blood extraction.",
      "washed_hands": "You have washed your hands with soap and warm water for 30 seconds.",
      "title": "Are you ready to begin sample collection?",
      "no_alcohol": "Do not drink alcohol on the day of collection.",
      "menstruation": "Do not collect vaginal swab specimen during menstruation or within 24 hours of intercourse."
    },
    "confirm": {
      "title": "Now, begin collecting your sample",
      "p1": "Is this kit information correct?"
    },
    "display_name": {
      "A": "Chlamydia & Gonorrhea (Single Site)",
      "B": "Chlamydia & Gonorrhea (3 Site)",
      "C": "Syphilis",
      "shortened": {
        "A": "Chlamydia & Gonorrhea",
        "B": "Chlamydia & Gonorrhea",
        "C": "Syphilis"
      },
      "CC": "COVID-19",
      "CE": "Celiac Disease Screening",
      "CR": "Creatinine Test",
      "D": "4 Panel Test - HIV, Syphilis, Chlamydia & Gonorrhea (Single Site)",
      "DD": "Diabetes Screening (HbA1c)",
      "E": "HIV & Syphilis",
      "H": "HPV",
      "P": "Hepatitis C",
      "HS": "Herpes Simplex",
      "I": "HIV",
      "TT": "Testosterone Level",
      "VD": "Vitamin D",
      "VS": "Viral Surveillance",
      "AP": "Chlamydia & Gonorrhea",
      "NN": "COVID-19",
      "HH": "COVID-19, Flu A/B, & RSV",
      "FFFWW": "COVID-19 & Flu A/B",
      "YYYWW": "COVID-19, Flu A/B & RSV",
      "HA": "COVID-19, Flu A/B, & RSV"
    },
    "rescan": "Rescan",
    "scanned": "You've scanned Box {{type}}",
    "not_yet": "Not Yet",
    "success_registration": "Registration success!",
    "no_box": "Don't have a box?",
    "faq_link": "Visit FAQs",
    "welcome": "Welcome!",
    "scan": {
      "title": "You're one step closer to a healthier you. Scan or enter the **kit bar code** on the side of your box.",
      "p1": "Please begin when you are ready to begin sample collection. Otherwise, return to this page when you are ready.",
      "unknown_barcode": "You’ve entered an unknown barcode. Please contact support for assistance."
    },
    "appointments": {
      "title": "Select the patient & provider",
      "p1": "We found more than one profile associated with your contact information. Select the correct profile:",
      "new": "New patient or provider"
    },
    "verify": {
      "title": "Confirm your identity",
      "p1": "We found your patient record."
    },
    "section_1": "Confirm kit contents",
    "section_2": "Test collection",
    "section_3": "Packaging",
    "section_4": "Return kit",
    "box_a": "Box A",
    "box_b": "Box B",
    "box_c": "Box C",
    "kit_flow": {
      "button_1": "Continue to packaging",
      "button_2": "I'm ready",
      "button_3": "My kit is complete and packed",
      "button_4": "I'm finished",
      "button_5": "Next test",
      "button_6": "Skip instructions"
    },
    "contents": {
      "header": "Great! Let's make sure your kit is complete",
      "text_1": "Does your test kit box contain the following?",
      "blood_collection_card": "Blood collection card",
      "blood_collection_card_subtitle": "(1 or 2 depending on test kit)",
      "alchohol_pads": "2 alcohol pads",
      "lancets": "Single use lancets",
      "up_to_other": "(Up to 4 depending on test kit)",
      "adhesive_bandages": "Adhesive bandages",
      "pipette": "Pipette",
      "urine_tube": "Urine collection tube",
      "urine_cup": "Urine collection cup",
      "oral_swab": "Oral swab",
      "oral_tube": "Oral collection tube",
      "anal_swab": "Anal swab",
      "anal_tube": "Anal collection tube",
      "vaginal_tube": "1 vaginal collection tube",
      "vaginal_swab": "1 vaginal swab",
      "biodegradable_paper": "Biodegradable collection paper",
      "bottle_and_probe": "Sampling bottle and probe",
      "prepaid_envelope": "Pre-paid shipping envelope",
      "biohazard_subtitle": "(with absorbent pad)",
      "biohazard_bag": "1 specimen bag",
      "biohazard_bag_plural": "({{count}}) Biohazard bags",
      "alcohol_pads_plural": "{{count}} alcohol pads",
      "sterile_gauze_pad": "1 sterile gauze pad",
      "collection_tube": "1 collection tube",
      "collection_swabs": "2 collection swabs"
    },
    "packaging": {
      "title": "Packaging checklist",
      "subtitle": "Before you ship or drop your kit at a kiosk, make sure that:"
    },
    "packaging_box_a": {
      "step_1": "You have packed all test kit contents according to the instructions",
      "step_2": "You have used all collection materials contained in the kit to collect the required specimen",
      "step_3": "Your **date-of-birth** is written on the specimen collection tube using MM/DD/YYYY format",
      "step_4": "The **collection date** is written on the specimen collection tube using MM/DD/YYYY format",
      "step_5": "The specimen collection tube is sealed in its biohazard bag",
      "step_6": "All specimens are placed into the box",
      "step_7": "The box is placed into the pre-paid shipping envelope",
      "step_8": "The return shipping envelope is completely sealed"
    },
    "packaging_box_b": {
      "step_1": "You have packed all test kit contents, even if you skipped the test(s)",
      "step_2": "You have used all collection materials contained in the kit to collect the required specimens",
      "step_3": "Your **date-of-birth** is written on all specimen collection tubes using MM/DD/YYYY format",
      "step_4": "The **collection date** is written on all specimen collection tubes using MM/DD/YYYY format",
      "step_5": "Each specimen collection tube is sealed in its own biohazard bag (only **one** specimen per bag)",
      "step_6": "All specimens are placed into the box",
      "step_7": "The box is placed into the pre-paid shipping envelope",
      "step_8": "The return shipping envelope is completely sealed"
    },
    "packaging_box_c": {
      "step_1": "You have packed all test kit contents, including used lancets.",
      "step_2": "Your **date-of-birth** is written on the blood collection card using MM/DD/YYYY format",
      "step_3": "The **collection date** is written on the blood collection card using MM/DD/YYYY format",
      "step_4": "The blood collection card and all used lancets are placed in the biohazard bag",
      "step_5": "The biohazard bag is placed into the box",
      "step_6": "The box is placed into the pre-paid shipping envelope",
      "step_7": "The return shipping envelope is completely sealed"
    },
    "success": {
      "header_1": "Great!",
      "text_1": "You're ready to collect your first sample.",
      "header_2": "You did it!",
      "text_2": "**Next up:** package your kit to send back.",
      "header_3": "Great job!",
      "text_3": "You’re one step closer to better health.",
      "header_4": "Nice job!",
      "text_4": "Just one more and you’re done!",
      "text_5": "You're ready to collect your sample."
    },
    "instructions": {
      "title": "Select a test to view instructions:",
      "subtitle": "Test",
      "button": "Instructions",
      "pdf": "PDF instructions"
    },
    "instructions_box_a": {
      "title": "Urine collection",
      "subtitle": "For this test you will need the following materials:",
      "step_1": "Do not urinate for at least 1 hour prior to collection. Using first morning urine is best.",
      "step_2": "Urinate directly into the PeeCanter or collection cup, filling between 1/3 and 1/2.",
      "step_3": "Pour from the PeeCanter or use the pipette to transfer urine from the collection cup into the collection tube(s) marked with an orange <span style=\"color: #FF5000\">**\"URINE\"**</span> label.",
      "step_4": "Fill the collection tube(s) until the combined liquid is between the designated fill lines.",
      "step_4_sublabel": "Do not fill tube past the maximum fill line or specimen will be rejected.",
      "step_5": "Place lid onto the collection tube and ensure it is closed evenly and tightly.",
      "step_6": "Write your date of birth and the specimen collection date (today’s date) in MM/DD/YYYY format onto the tube in the designated area.",
      "step_7": "Place specimen into an empty biohazard bag with the absorbent pad and ensure the seal is closed completely."
    },
    "instructions_box_b": {
      "test_1": {
        "title": "Urine collection",
        "subtitle": "For this test you will need the following materials:",
        "step_1": "Do not urinate for at least 1 hour prior to collection. Using first morning urine is best.",
        "step_2": "Urinate directly into the PeeCanter or collection cup, filling between 1/3 and 1/2.",
        "step_3": "Pour from the PeeCanter or use the pipette to transfer urine from the collection cup into the collection tube(s) marked with an orange <span style=\"color: #FF5000\">**\"URINE\"**</span> label.",
        "step_4": "Fill the collection tube(s) until the combined liquid is between the designated fill lines.",
        "step_4_subtitle": "Do not fill tube past the maximum fill line or specimen will be rejected.",
        "step_5": "Place lid onto the collection tube and ensure it is closed evenly and tightly.",
        "step_6": "Write your date of birth and the specimen collection date (today’s date) in MM/DD/YYYY format onto the tube in the designated area.",
        "step_7": "Place specimen into an empty biohazard bag with the absorbent pad and ensure the seal is closed completely."
      },
      "test_2": {
        "title": "Oral swab",
        "subtitle": "For this test you will need the following materials:",
        "step_1": "Hold the swab between the faint score line (if present) and the cotton-topped portion of the swab.",
        "step_2": "Insert the swab into your mouth and rub the swab tip against the back of your throat for 10 seconds.",
        "step_3": "Carefully withdraw the swab and place into the collection tube marked with a blue <span style=\"color: #001F70\">**\"ORAL\"**</span> label. Break the swab at the score line by bending against the collection tube.",
        "step_4": "Place lid onto the collection tube and ensure it is closed evenly and tightly.",
        "step_5": "Write your date of birth and the specimen collection date (today’s date) in MM/DD/YYYY format onto the tube in the designated area.",
        "step_6": "Place specimen into an empty biohazard bag with the absorbent pad and ensure the seal is closed completely."
      },
      "test_3": {
        "title": "Anal swab",
        "subtitle": "For this test you will need the following materials:",
        "step_1": "Hold the swab between the faint score line (if present) and the cotton-topped portion of the swab.",
        "step_2": "Insert the swab 3 - 5 cm (1 - 2”) into the anal canal. Gently turn the swab for 5 - 10 seconds to collect any potential organisms.",
        "step_3": "Carefully withdraw the swab and place into the collection tube marked with a green <span style=\"color: #00C08C\">**“ANAL”**</span> label. Break the swab at the score line by bending against the collection tube.",
        "step_4": "Place lid onto the collection tube and ensure it is closed evenly and tightly.",
        "step_5": "Write your date of birth and the specimen collection date (today’s date) in MM/DD/YYYY format onto the tube in the designated area.",
        "step_6": "Place specimen into an empty biohazard bag with the absorbent pad and ensure the seal is closed completely."
      }
    },
    "instructions_box_c": {
      "title": "Blood collection",
      "subtitle": "For this test you will need the following materials:",
      "step_1": "Write your name, date of birth, and the date of collection in the designated fields. Use MM/DD/YYYY format.",
      "step_2": "Open blood card flap to expose the circles on the blood collection paper. Do not touch the blood collection paper.",
      "step_3": "Wash hands with warm water for at least 30 seconds, then shake hands vigorously for 15 seconds to encourage blood flow to your fingers.",
      "step_4": "Clean fingertip with alcohol pad. It is best to use the middle or ring finger of your non-dominant hand.",
      "step_5": "Take the lancet and twist off the cap. Press the small tip firmly into the tip of your finger, until the needle ejects with a click. Keeping your hand below your heart during collection, massage finger from base to tip to encourage blood flow.",
      "step_5_subtitle": "Lancets are single use. All lancets need to be returned with your sample to the laboratory for disposal.",
      "step_6": "Starting at the center, apply 3-6 drops to fill the circle and soak through the collection paper. Do not touch the paper with your finger as this will restrict blood flow. Once circle is full, move on to next circle. It is okay for blood to extend beyond lines, but do not let blood spots spread into each other.",
      "step_6_subtitle": "Do not add additional blood to a circle once completed or dry. The “layering” of blood will invalidate the collection.",
      "step_7": "Without closing the blood card, lay it on a flat surface and allow the blood collection paper to air dry at room temperature, for at least 30 minutes. Do not heat, blow dry, or expose the blood collection paper to direct sunlight. Heat will damage the specimen.",
      "step_7_subtitle": "Check the back side of blood collection paper. Blood should saturate all the way through and fill each circle of the collection paper.",
      "step_8": "When blood collection paper is dry, close blood card by tucking flap. Place the blood card and lancets into biohazard bag with the desiccant pack. Ensure biohazard bag is properly sealed."
    },
    "test_tips": {
      "title": "Tips for Proper Blood Collection",
      "subtitle": "For best results:",
      "step_1": "Be sure you are not dehydrated while performing collection. Hydration promotes blood flow.",
      "step_2": "Do not perform collection immediately after smoking.",
      "step_3": "Washing and warming your hands under warm water will help promote blood flow in your hands.",
      "step_4": "Shake hands vigorously towards the floor to encourage blood flow to your fingers.",
      "step_5": "Keep collection device and hands below your heart during collection for best blood flow.",
      "step_6": "You may need more than one finger prick. Repeat these tips between each finger prick."
    },
    "shipping": {
      "header": "Your kit is ready to ship!",
      "text": "**Congrats!** You finished your health screening."
    },
    "pick_up": "Pick up your recommended test kit from the site staff and register below",
    "short_display_name": {
      "A": "Chlamydia & Gonorrhea",
      "B": "Chlamydia & Gonorrhea",
      "C": "Syphilis",
      "CC": "Colorectal Cancer",
      "CE": "Celiac",
      "CR": "Creatinine",
      "D": "HIV, Syphilis, Chlamydia & Gonorrhea",
      "DD": "Diabetes",
      "E": "HIV & Syphilis",
      "H": "HPV",
      "P": "Hepatitis C",
      "HS": "Herpes Simplex",
      "I": "HIV",
      "TT": "Testosterone",
      "VD": "Vitamin D",
      "VS": "Viral Surveillance"
    },
    "test_kit": "Test Kit",
    "view_results": "View results",
    "recommended_kit_title": "Recommended Test Kits",
    "instructions_box_h": {
      "title": "Vaginal Swab Collection",
      "subtitle": "Collection tubes may contain a liquid preservative. <span class=\"text-danger\">**Do not empty liquid preservative from the collection tubes if present.**</span>",
      "step_1": "Hold the swab between the faint score line (if present) and the cotton-tipped portion of the swab in one hand and separate the labia (folds of skin around the vaginal opening).",
      "step_2": "Insert the swab 5cm (2in) into the vaginal opening. Gently turn the swab for 30 seconds while rubbing the swab against the walls of the vagina.",
      "step_3": "Carefully withdraw the swab and place into the collection tube marked with a <span class=\"text-danger\">**RED “VAGINAL” LABEL**</div>. Break the swab by bending against the collection tube.",
      "step_4": "Place lid onto the collection tube and ensure it is closed evenly and tightly.",
      "step_5": "Write your date of birth in MM/DD/YYYY format onto the tube in the designated area (DOB).",
      "step_6": "Write the specimen collection date (today’s date) in MM/DD/YYYY format onto the tube in the designated area (Coll. Date).",
      "step_7": "Place specimen into the empty biohazard bag with the absorbent pad and ensure the seal is closed completely."
    },
    "packaging_box_h": {
      "step_3": "Your **date-of-birth** is written on the specimen collection tube using MM/DD/YYYY format",
      "step_4": "Your **collection date** is written on the specimen collection tube using MM/DD/YYYY format",
      "step_6": "The biohazard bag is placed into the box"
    },
    "instructions_box_cc": {
      "title": "Stool collection",
      "step_1": "Write your date of birth and the specimen collection date (today’s date) in MM/DD/YYYY format onto the tube in the designated area. Open green cap by twisting and lifting.",
      "step_2": "Place supplied collection paper into toilet bowl on top of water.",
      "step_3": "Deposit stool sample on top of collection paper.",
      "step_4": "Collect sample from stool before paper sinks and stool sample touches water.",
      "step_5": "Scrape the surface of the fecal sample with the sample probe.",
      "step_6": "Cover the grooved portion of the sample probe completely with stool sample.",
      "step_7": "Close sampling bottle by inserting sample probe and snapping green cap on tightly. Do not reopen.",
      "step_8": "Flush. Collection paper is biodegradable and will not harm septic systems.",
      "step_9": "Wrap sampling bottle in absorbent pad and insert in to  the biohazard bag."
    },
    "contact_support": {
      "title": "Let's fix this",
      "text_1": "We are sorry to hear that something is wrong!",
      "text_2": "Please contact us to let us know what’s wrong and we will help to replace your kit."
    },
    "contact_support_success": {
      "title": "We received your message",
      "text_1": "Thanks for contacting us.",
      "text_2": "A member of our support team will be in touch soon.",
      "button_text": "Return home"
    },
    "kit_in_transit_to_patient": "Your order is on its way! Most orders are delivered within 2-5 business days. Once you receive your kit, we will send you more information on how to activate it and send it back.\n\nTracking Link: https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum={{tracking_number}}",
    "kit_received_at_lab": "The lab received your kit! You'll receive a notification to check your patient portal when results are ready",
    "registration_confirmation": "Your registration is now complete! Visit your registration confirmation page to activate your test kit:",
    "kit_ordered_online": "We've received your kit order and we will send an update once it ships! \n\nOrder #: {{order_number}} \nOrder date: {{order_date}}",
    "kit_ordered_online_email": {
      "header": "We received your order!",
      "p1": "We've received your order! Once your order ships, we'll send you another update.",
      "order_number": "Order #",
      "order_date": "Order date"
    },
    "completed": "Completed",
    "I": "this kit includes tests for HIV.",
    "CC": "this kit includes tests for COVID-19.",
    "CE": "this kit includes tests for celiac disease.",
    "CR": "this kit includes tests for creatinine.",
    "DD": "this kit includes tests for diabetes.",
    "H": "this kit includes tests for HPV.",
    "P": "this kit includes tests for hepatitis C.",
    "HH": "this kit includes tests for COVID-19, Flu A/B, and RSV.",
    "HS": "this kit includes tests for HSV-2.",
    "TT": "this kit includes tests for testosterone.",
    "VD": "this kit includes tests for vitamin D.",
    "nasal_collection": {
      "title": "Nasal collection",
      "subtitle": "For this test you will need the following materials:",
      "step_1": "Write your Date of Birth and the Collection Date on your collection tube. Use MM/DD/YYYY format for the dates (i.e., 08/29/2023).",
      "step_2": "Wash your hands with soap and water thoroughly before proceeding and after completeing all steps.",
      "step_3": "Remove the swab from the wrapper with your clean hands. Hold the swab with the white tip up. Do not touch the tip of the swab to anything.",
      "step_4": "Holding the swab with one hand, gently insert the white tip of the swab about 1/2 to 3/4 inces (1 to 2 cm) into the opening of your nose. Rotate the swab for 15 to 30 seconds. Make sure the swab touches the insides of your nose. Remove the swab from your nose being careful not to touch your skin. Do not set the swab down. Repeat in the other nostril.",
      "step_5": "While still holding the swab, unscrew and remove the cap from the transport tube without setting the cap down. Place the swab into the tube with the white tip down, taking great care not to spill or splash the liquid in the collection tube.",
      "step_6": "Place lid onto the collection tube and ensure it is closed evenly and tightly.",
      "step_7": "Place specimen into the empty biohazard bag with the absobent pad and ensure the seal is closed completely. Return the biohazard bag to the kiosk drop box."
    },
    "NN": "this kit includes tests for COVID-19.",
    "YYYWW": "this kit includes tests for COVID-19, Flu A/B, and RSV.",
    "FFFWW": "this kit includes tests for COVID-19 and Flu A/B.",
    "HA": "this kit includes tests for COVID-19, Flu A/B, and RSV.",
    "drop_off": {
      "header": "Your kit is ready to drop off!"
    },
    "view_instructions": "View instructions",
    "return_test_strip_reminder": "You registered your test kit, but we haven't received your sample. Please return it ASAP for timely results.",
    "contact_us": "If you have any questions, please contact us at <a href=tel:{{phone_number}}>{{formatted_phone_number}}</a>.",
    "contact_us_short": "Questions? {{phone_number}}."
  },
  "copy_link": "কপি পেজের লিঙ্ক",
  "copied_link": "কপি করা লিঙ্ক!",
  "vaccines": {
    "descriptions": {
      "vaccine_flu": "সাধারণ ফ্লু ভাইরাসের জন্য সাবধানতা",
      "vaccine_covid": "COVID-19 ভাইরাসের বিরুদ্ধে সাবধানতা",
      "tdap": "TDap ভ্যাকসিন টিটেনাসকে আটকাতে পারে",
      "polio": "পোলিও ভাইরাসের বিরুদ্ধে সাবধানতা। স্কুল শুরু হওয়ার আগেই বাচ্চাদের জন্য জরুরী।",
      "varicella": "ভ্যাকসিন যা চিকেনপক্সের রোধক",
      "shingles": "ভ্যাকসিন যাা দাদের বিরুদ্ধে লড়াই করে। কমপক্ষে 18 বছর হওয়া জরুরী।",
      "human_papillomavirus": "ভ্যাকসিন যা HPV এর বিরুদ্ধে লড়াই করে। 11 বছর বয়সী বাচ্চাদের জন্য প্রস্তাবিত।",
      "meningococcal": "ভ্যাকসিন যা চার ধরণের মেনিনজোগোকাল ব্যাকটেরিয়ার বিরুদ্ধে লড়াই করে।"
    }
  },
  "viral_surveillance": {
    "shipping": {
      "title": "Prepare to ship your sample:",
      "step_1": {
        "label": "Put the biohazard bag into box.",
        "substep_1": "Remove the return shipping mailer from your test kit.",
        "substep_2": "Place the biohazard bag into the original collection kit box and close the box."
      },
      "step_2": {
        "label": "Put box into return shipping mailer.",
        "substep_1": "Place the box into the return shipping mailer and seal the mailer.",
        "substep_2": "Do not fold or cover the UN3373 diamond symbol."
      },
      "step_3": {
        "label": "Return to Fedex location.",
        "substep_1": "Return kit on the same day of collection (before the last pickup) to a Fedex location.",
        "substep_2": "Call for a FedEx pickup at 1.800.GoFedEx."
      }
    },
    "overview": {
      "title": "Welcome to the Viral Sequencing Program!",
      "subtitle": "Your participation helps provide valuable information on which respiratory pathogen variants are circulating in your area. Please follow the instructions that came with your kit to get started."
    },
    "instructions": {
      "title": "Collect your sample:",
      "step_1": "Wash your hands.",
      "step_2": "Remove the cap of the collection tube and open the swab package.",
      "step_2a": "Remove the swab from the package. Do not touch the soft end with your hands or anything else.",
      "step_3": "Collect a nasal swab.",
      "step_3a": "Insert the entire soft end of the swab into your nostril no more than 3/4 of an inch (1/5cm) into your nose.",
      "step_3b": "Slowly rotate the swab",
      "step_3c": "Gently remove the swab.",
      "step_3d": "Using the same swab, repeat in your other nostril with the same end of the swab.",
      "step_4": "Put swab into the collection tube and cap the tube securely.",
      "step_5": "Put the collection tube into the biohazard bag and seal.",
      "step_6": "Apply even pressure to the ziplock to seal the bag shut."
    },
    "click_to_get_started_button": "Click to get started",
    "get_started_button": "Get started",
    "thank_you": {
      "title": "Thank you for using Primary.Health!",
      "p_3": "You may now close the browser.",
      "p_2": "Please make sure to drop off the viral surveillance kit at your closest FedEx location.",
      "p_1": "Your participation actively helps Public Health officials fight the spread of disease. If you would like to see the impact you are making on Public Health, please take a moment to explore more via [this link]({{link}}). You will not be contacted about your results, as they are anonymous."
    },
    "verify_dob_title": "First, let's confirm your details",
    "verify_dob_subtitle": "This helps us ensure the correct person is using the test kit.",
    "activate_kit": "Activate a kit:",
    "steps_complete": "Steps complete",
    "opt_in": {
      "section_1_title": "How it works",
      "section_1_text_1": "Sign up below and receive a viral sequencing test kit in 1-3 business days.",
      "section_1_text_2": "Upon receiving the test kit",
      "section_1_text_3": "Send the sample back per the instructions in the kit using our prepaid label.",
      "sign_up": "Sign me up!",
      "no_to_participate": "No",
      "section_2_title": "What is the impact of your participation?",
      "section_2": {
        "card_1_title": "Rapid response to new variants",
        "card_1_text": "Genetic sequencing helps track the spread and emergence of new respiratory pathogen variants, allowing public health systems to quickly ramp up preparedness efforts.",
        "card_2_title": "Track how Respiratory Pathogens are changing",
        "card_2_text": "Respiratory pathogen sequencing analyzes the “genetic blueprint” of the virus. This helps scientists trace how the virus changes, enabling it to spread more easily, make people more sick",
        "card_3_title": "You have complete privacy",
        "card_3_text": "The sequencing will be processed anonymously. The lab will never contact you about your results"
      },
      "title": "You’re eligible for California’s Free Respiratory Pathogen Viral Sequencing Project!",
      "subtitle": "You can help public health officials protect communities against respiratory pathogens! If you opt in to participate you will receive a free viral sequencing kit that will test what respiratory pathogen strain you are infected with. Results will help officials track the spread of respiratory pathogen variants. See below for more information and to sign up.",
      "continue_to_result": "Continue to my result",
      "create_page_title": "Thank you!",
      "create_page_text_1": "Your kit should arrive in the next 1-3 business days.",
      "create_page_text_2": "Your participation actively helps Public Health officials fight the spread of diseases. You will be notified when your test kit order has been approved and when it has shipped."
    }
  },
  "family_registrations": {
    "find_clinic": "একটি ক্লিনিক খুঁজুন",
    "select_pin": "সম্পূর্ণ তথ্য দেখতে একটি পিন নির্বাচন করুন",
    "miles_shorten": "{{miles}} mi",
    "next_available": "পরবর্তী  উপলব্ধ",
    "appointment_type": "অ্যাপয়েন্টমেন্টের ধরণ",
    "individual_appointment": "একক অ্যাপয়েন্টমেন্ট",
    "family_appointment": "পারিবারিক অ্যাপয়েন্টমেন্ট",
    "vaccines": "ভ্যাকসিন",
    "what_kind_appointment": "আপনি কি ধরণের অ্যাপয়েন্টমেন্ট বুক করতে চান?",
    "select_family_or_individual": "যদি আপনি একসাথে অনেকগুলি পরিবারের জন্য বুক করতে চান তাহলে পারিবারিক অ্যাপয়েন্টমেন্ট নির্বাচন করুন।",
    "vaccines_selected": "নির্বাচিত ভ্যাকসিন",
    "where_care": "আপনি কোথায় কেয়ার পেতে চান?",
    "select_vaccines_for_individual": "আপনার অ্যাপয়েন্টমেন্টের জন্য ভ্যাকসিন নির্বাচন করুন (ঐচ্ছিক)।",
    "select_vaccines_for_family": "আপনার পারিবারিক অ্যাপয়েন্টমেন্টের জন্য ভ্যাকসিন নির্বাচন করুন (ঐচ্ছিক)।",
    "schedule_services": "সার্ভিসের সময় নির্বাচন করুন",
    "add_family": "পরিবারের সদস্যদের যুক্ত করুন এবং নিম্নলিখিত থেকে প্রয়োজনীয় পরিষেবাটি বেছে নিন।",
    "family_member": "পরিবারের সদস্য {{number}}",
    "morning": "সকাল",
    "afternoon": "বিকেল",
    "slot_available": "{{number}} উপলব্ধ",
    "within_x_miles": "{{miles}} মাইলের মধ্যে",
    "any_distance": "যে কোনো দূরত্বে",
    "partial_results": "আংশিক ফলাফল",
    "partial_matches": "নির্বাচিত ক্লিনিকটি আপনার প্রয়োজনীয় ভ্যাকসিনগুলির মধ্যে কিছু দিতে পারবে সবগুলি নয়",
    "no_matches": "আপনার খোঁজ অনুযায়ী কোনো ফলাফল পাওয়া যায়নি। আরও ভালো ফলের জন্য আপনার ফিল্টারে পরিবর্তন করুন।",
    "no_clinics_found": "এমন কোনো ক্লিনিক নেই যা আপনার সার্চের সাথে সামঞ্জস্যপূর্ণ।",
    "broaden_filters": "ভালো ফল পাওয়ার জন্য ফিল্টারের পরিধি বাড়ান।",
    "unavailable_vaccines": "অনুপলব্ধ ভ্যাকসিন:",
    "available_vaccines": "উপলব্ধ ভ্যাকসিন:",
    "select_date": "একটি তারিখ নির্বাচন করুন",
    "available_appointments": "উপলব্ধ অ্যাপয়েন্টমেন্ট",
    "appointment_scheduling_info": "পরবর্তী ধাপে আপনার পরিবারের একজন নির্দিষ্ট সদস্যের জন্য অ্যাপয়েন্টমেন্ট নির্ধারণ করতে পারবেন। আপনার ইচ্ছানুসারে আপনি আলাদা আলাদা দিনেও অ্যাপয়েন্টমেন্ট নিতে পারেন।",
    "hold_selected_appointments": "আমরা আপনার নির্বাচিত অ্যাপয়েন্টমেন্টটি 15 মিনিটের জন্য হোল্ড করছি",
    "appointments_selected": "নির্বাচিত অ্যাপয়েন্টমেন্ট",
    "no_appointments_selected": "কোনো অ্যাপয়েন্টমেন্ট নির্বাচন করা হয়নি",
    "vaccines_needed": "প্রয়োজনীয় ভ্যাকসিন",
    "select_x_appointments": "{{number}} নির্বাচিত অ্যাপয়েন্টমেন্ট।",
    "more": "আরও বেশী",
    "less": "কম",
    "register_next_family_member": "পরবর্তী পরিবারের সদস্যকে নিবন্ধন করুন",
    "successfully_registered_x_of_y_family_members": "পরিবারের {{y}} জন সদস্যের মধ্যে {{x}} জন সদস্যকে আপনি সফলভাবে নিবন্ধন করিয়েছেন",
    "next_family_member": "পরিবারের পরবর্তী সদস্য",
    "appointments_abbreviated": "appts",
    "register_for_clinic": "ক্লিনিকের জন্য নিবন্ধন করুন",
    "select_services": "পরিষেবা নির্বাচন করুন",
    "person": "ব্যক্তি {{number}}",
    "add_person": "অন্য ব্যক্তিকে যুক্ত করুন",
    "registration_confirmation": "নিবন্ধনের নিশ্চিতকরণ"
  },
  "user_mailer": {
    "verify_email": "এবার আপনার ইমেইলটি যাচাই করা যাক!",
    "hi_full_name": "নমস্কার {{full_name}},",
    "verify_email_button": "ইমেইল যাচাই করুন",
    "please_verify_email": "আপনার ইমেইলটি যাচাই করতে অনুগ্রহ করে নীচের বোতামটি ব্যবহার করুন।"
  },
  "services": {
    "dptap_dt": "DTaP/Tdap/Td",
    "hepatitis_a": "হেপাটাইটিস A",
    "hepatitis_b": "হেপাাটাইটিস B",
    "hepatitis_a_b": "হেপাটাইটিস A এবং B",
    "hib": "Hib",
    "mmr": "হাম, মাম্পস, রুবেলা",
    "meningococcal": "মােনিনজোগোকাল",
    "mpox": "Mpox",
    "pneumococcal": "নিউমোগোকাল",
    "polio": "পোলিও",
    "rsv": "রেসপিরেটরি সিন্সিশিয়াল ভাইরাস",
    "rotovirus": "রোটাভাইরাস",
    "zoster": "জলফোসকা (দাদ)",
    "tetanus_diptheria": "টিটেনাস ও ডিপথেরিয়া",
    "tdap": "Tdap",
    "typhoid": "টাইফয়েড",
    "varicella": "ভ্যারিসেলা (চিকেনপক্স)",
    "covid-19": "COVID-19",
    "covid-19_adult": "COVID-19 (প্রাপ্তবয়স্ক)",
    "covid-19_adult_description": "12 বছর ও তার বেশী বয়সীদের জন্য।",
    "covid-19_children": "COVID-19 (বাচ্চা)",
    "covid-19_children_description": "4 - 11 বছর বয়সী বাচ্চাদের জন্য",
    "covid-19_infants": "COVID-19 (শিশু)",
    "covid-19_infants_description": "6 মাস - 3 বছর বয়সী শিশুদের জন্য।",
    "influenza": "ইনফ্লুয়েঞ্জা",
    "mmrv": "হাম, মাম্পস, রুবেলা ও ভ্যারিসেলা"
  },
  "deep_archived": {
    "admin": "ডেটা সুরক্ষার উদ্দেশ্যে, {{test_group_name}} ({{slug}}) গ্রুপের সকল ডেটা সংরক্ষিত রাখা হয়েছে এবং সেগুলি এখন এই পেজ থেকে আর কোনোভাবেই দেখা বা পরিবর্তন করা সম্ভব নয়। যদি আপনার কোনো সহায়তার প্রয়োজন হয় তাহলে অনুগ্রহ করে আপনার অ্যাকাউন্ট ম্যানেজারের সাথে যোগাযোগ করুন অথবা support@primary.health এ ইমেইল করুন।",
    "participant": "এই পেজটি আর উপলব্ধ নয়। অনুগ্রহ করে হেল্থ ক্যাম্পেইনের মধ্যে আপনার সাথে যোগাযোগ আছে এমন কারোর সাথে যোগাযোগ করুন: {{test_group_name}}. আপনার পুরোনো কোনো রেকর্ড দেখতে অসুবিধা হলে, অন্যগ্রহ করে সহায়তার জন্য support@primary.health এ যোগাযোগ করুন।"
  }
}